{
  "_lxAlertMarkdownExample": "$$https://www.test.de::Test$$ *--Hier--* ***können*** ##-br-## Sie **__Änderungen__** an **--Ihren--** *Accountdaten vornehmen*. __Aber__ nur *wenn sie* auch ##-br-## --wirklich-- wollen.",
  "account": {
    "autocomplete": {
      "placeholder": "Anrede",
      "title": "Anrede"
    },
    "button": {
      "changeEmailAddress": {
        "title": "E-Mail-Adresse ändern",
        "tooltip": {
          "h": "E-Mail-Adresse ändern",
          "t": "Hier können Sie Ihre E-Mail-Adresse ändern."
        }
      },
      "changeLoginName": {
        "title": "Benutzername ändern",
        "tooltip": {
          "h": "Benutzername ändern",
          "t": "Hier können Sie Ihren Benutzernamen ändern."
        }
      },
      "changePassword": {
        "title": "Passwort ändern",
        "tooltip": {
          "h": "Passwort ändern",
          "t": "Hier können Sie Ihr Passwort ändern."
        }
      },
      "generateBackupCodes": {
        "title": "Backup-Codes neu generieren",
        "tooltip": {
          "h": "Neugenerierung",
          "t": "Hier können Sie Ihre Backup-Codes neu erzeugen lassen."
        }
      },
      "twoFactorActivation": {
        "title": "2FA aktivieren",
        "tooltip": {
          "h": "Zweifaktorauthentifizierung",
          "t": "Hier können Sie Ihre Zweifaktorauthentifizierung aktivieren."
        }
      },
      "twoFactorDeactivation": {
        "title": "2FA deaktivieren",
        "tooltip": {
          "h": "Zweifaktorauthentifizierung",
          "t": "Hier können Sie Ihre Zweifaktorauthentifizierung deaktiveren."
        }
      }
    },
    "expansionPanel": {
      "data": {
        "header": "Grunddaten",
        "subheader": "Verwaltung personenbezogener Daten"
      },
      "security": {
        "header": "Accountsicherheit",
        "subheader": "Verwaltung von Benutzername, E-Mail-Adresse, Passwortänderung sowie Zwei-Faktor-Authentifizierung"
      }
    },
    "input": {
      "email": {
        "placeholder": "E-Mail",
        "title": "E-Mail"
      },
      "firstName": {
        "placeholder": "Bitte geben Sie Ihren Vornamen ein.",
        "title": "Vorname"
      },
      "lastName": {
        "placeholder": "Bitte geben Sie Ihren Nachnamen ein.",
        "title": "Nachname"
      },
      "loginName": {
        "placeholder": "Benutzername",
        "title": "Benutzername"
      }
    },
    "select": {
      "salutation": {
        "gender": {
          "divers": {
            "adjective": "divers",
            "noun": "Divers",
            "salutation": "geschlechtsneutral (divers)"
          },
          "female": {
            "adjective": "weiblich",
            "noun": "Frau",
            "salutation": "Frau"
          },
          "male": {
            "adjective": "männlich",
            "noun": "Herr",
            "salutation": "Herr"
          }
        },
        "placeholder": "Anrede",
        "title": "Anrede"
      },
      "title": {
        "academicTitle": {
          "dr": "Dr.",
          "drMed": "Dr. Med.",
          "drRerNat": "Dr. rer. nat.",
          "prof": "Prof."
        },
        "hint": "Alle folgenden Titel können mehrfach vergeben werden.",
        "placeholder": "Titel",
        "title": "Titel"
      }
    }
  },
  "account_app": {
    "app_settings": "App-Einstellungen",
    "app_settings_info": "Individualisieren Sie die Anwendung",
    "dashboard": "Dashboard",
    "header_navigation": "Navigation",
    "info_navigation": "Wichtige Informationen auf einen Blick"
  },
  "button": {
    "accept": {
      "title": "Daten bestätigen",
      "tooltip": {
        "t": "Daten bestätigen"
      }
    },
    "activate_2fa": {
      "title": "Zweifaktorauthentifizierung",
      "tooltip": {
        "h": "Zweifaktorauthentifizierung",
        "t": "Hier können Sie nun Ihre Zweifaktorauthentifizierung aktivieren."
      }
    },
    "add": {
      "title": "Hinzufügen",
      "tooltip": {
        "h": "Hinzufügen",
        "t": "Datensatz hinzufügen"
      }
    },
    "add_cycle": {
      "title": "Zyklus hinzufügen"
    },
    "add_office_hours": {
      "title": "Öffnungszeiten bearbeiten",
      "tooltip": {
        "h": "Bearbeiten",
        "t": "Öffnungszeiten bearbeiten"
      }
    },
    "add_therapy": {
      "title": "Therapien erstellen"
    },
    "add_vital_data": {
      "title": "Vitaldaten hinzufügen",
      "tooltip": {
        "h": "Vitaldaten hinzufügen",
        "t": "Hier können Sie neue Vitaldaten hinzufügen"
      }
    },
    "apply_therapies": {
      "title": "Absagen",
      "tooltip": {
        "h": "Therapien verabreichen",
        "t": "Therapien auf verabreicht setzen"
      }
    },
    "approve": {
      "title": "Freigabe",
      "tooltip": {
        "h": "Freigabe",
        "t": "Ausgewählte Therapien freigeben."
      }
    },
    "arrow_down": {
      "title": "Nach unten",
      "tooltip": {
        "h": "Nach unten",
        "t": "Element nach unten verschieben"
      }
    },
    "arrow_up": {
      "title": "Nach oben",
      "tooltip": {
        "h": "Nach oben",
        "t": "Element nach oben verschieben"
      }
    },
    "back": {
      "title": "Zurück",
      "tooltip": {
        "h": "Zurück",
        "t": "Hier gelangen Sie zurück zur Übersicht."
      }
    },
    "cancel": {
      "title": "Abbrechen",
      "tooltip": {
        "h": "Abbrechen",
        "t": "Hier können Sie den Vorgang abbrechen."
      }
    },
    "cancel_therapies": {
      "title": "Absagen",
      "tooltip": {
        "h": "Therapien absagen",
        "t": "Therapien absagen."
      }
    },
    "change_email": {
      "title": "E-Mail-Adresse ändern",
      "tooltip": {
        "h": "E-Mail-Adresse ändern",
        "t": "Hier können Sie Ihre E-Mail-Adresse ändern."
      }
    },
    "change_login": {
      "title": "Benutzername ändern",
      "tooltip": {
        "h": "Benutzername ändern",
        "t": "Hier können Sie Ihren Benutzernamen ändern."
      }
    },
    "close": {
      "title": "Schließen",
      "tooltip": {
        "h": "Schließen",
        "t": "Schließen"
      }
    },
    "close_patient_schema": {
      "title": "Schließen",
      "tooltip": {
        "h": "Schließen",
        "t": "Hier können Sie das Patientenschema schließen."
      }
    },
    "create_empty_patient_schema": {
      "title": "Leeres Patientenschema erstellen",
      "tooltip": {
        "h": "Leeres Patientenschema erstellen",
        "t": "Hier können Sie ein leeres Patientenschema erstellen."
      }
    },
    "create_empty_praxis_schema": {
      "title": "Leeres Praxisschema erstellen",
      "tooltip": {
        "h": "Leeres Praxisschema erstellen",
        "t": "Hier können Sie ein leeres Praxisschema erstellen."
      }
    },
    "create_overview": {
      "title": "Applikationsübersicht drucken",
      "tooltip": {
        "h": "Applikationsübersicht erstellen",
        "t": "Hier können Sie eine Applikationsübersicht drucken."
      }
    },
    "create_patient_schema": {
      "title": "Patientenschema erstellen",
      "tooltip": {
        "h": "Patientenschema erstellen",
        "t": "Hier können Sie das Patientenschema erstellen."
      }
    },
    "create_praxis_schema": {
      "title": "Praxisschema erstellen",
      "tooltip": {
        "h": "Praxisschema erstellen",
        "t": "Hier können Sie ein Praxisschema erstellen."
      }
    },
    "createTherapies": {
      "title": "Therapien erstellen",
      "tooltip": {
        "h": "Therapien erstellen",
        "t": "Hier können Sie Therapien erstellen."
      }
    },
    "deactivate_2fa": {
      "title": "Zweifaktorauthentifizierung",
      "tooltip": {
        "h": "Zweifaktorauthentifizierung",
        "t": "Hier können Sie nun Ihre Zweifaktorauthentifizierung deaktivieren."
      }
    },
    "delete": {
      "title": "Löschen",
      "tooltip": {
        "h": "Löschen",
        "t": "Ausgewählte Therapien löschen."
      }
    },
    "delete_contact": {
      "title": "Kontaktdaten löschen",
      "tooltip": {
        "h": "Kontaktdaten löschen",
        "t": "Hier können Sie die Kontaktdaten löschen."
      }
    },
    "deleteUser": {
      "title": "Nutzer löschen",
      "tooltip": {
        "h": "Nutzer löschen",
        "t": "Hier können Sie den ausgewählten Nutzer löschen."
      }
    },
    "discard_forever": {
      "title": "Patient dauerhaft für Import sperren",
      "tooltip": {
        "h": "Patient sperren",
        "t": "Hier können Sie den Patient dauerhaft für den Import sperren."
      }
    },
    "discard_in_import": {
      "title": "Patient für diesen Import verwerfen",
      "tooltip": {
        "h": "Patient für diesen Import verwerfen",
        "t": "Hier können Sie den Patient für den aktuellen Import verwerfen."
      }
    },
    "discard_patient": {
      "title": "Patient verwerfen",
      "tooltip": {
        "h": "Patient verwerfen",
        "t": "Hier können Sie den Patient verwerfen."
      }
    },
    "drop": {
      "title": "Wählen Sie eine Datei aus",
      "tooltip": {
        "h": "Dateiauswahl",
        "t": "Hier können Sie eine Datei zum Hochladen auswählen."
      }
    },
    "edit_blacklist": {
      "title": "Liste gesperrter Patienten bearbeiten",
      "tooltip": {
        "h": "Liste gesperrter Patienten bearbeiten",
        "t": "Hier können Sie die Liste gesperrter Patienten bearbeiten."
      }
    },
    "end": {
      "title": "Beenden",
      "tooltip": {
        "h": "Beenden",
        "t": "Hier können Sie beenden."
      }
    },
    "finishProcess": {
      "title": "Vorgang abschließen",
      "tooltip": {
        "h": "E-Mail-Änderung durchführen",
        "t": "Hier können Sie nun Ihre E-Mail ändern."
      }
    },
    "generate_new_codes": {
      "title": "Backup-Codes neu generieren",
      "tooltip": {
        "h": "Backup-Codes neu generieren",
        "t": "Hier können Sie nun Ihre Backup-Codes neu generieren lassen."
      }
    },
    "import": {
      "title": "Neuen Import starten",
      "tooltip": {
        "h": "Neuen Import starten",
        "t": "Hier können Sie einen neuen Import starten."
      }
    },
    "invite": {
      "title": "Neue Einladung",
      "tooltip": {
        "h": "Neue Einladung",
        "t": "Neue Einladung(en) versenden"
      }
    },
    "login": {
      "title": "Anmelden",
      "tooltip": {
        "h": "Anmelden",
        "t": "Hier können Sie sich einloggen."
      }
    },
    "logout": {
      "title": "Abmelden",
      "tooltip": {
        "h": "Abmelden",
        "t": "Hier können Sie sich ausloggen."
      }
    },
    "migrate_partner": {
      "title": "Arzt migrieren",
      "tooltip": {
        "h": "Migration",
        "t": "Migration vom ausgewählten Arzt, dessen Patienten, Patientenschemen und Therapien."
      }
    },
    "new": {
      "title": "Neu anlegen",
      "tooltip": {
        "h": "Neu anlegen",
        "t": "Hier können Sie neue Daten anlegen."
      }
    },
    "new_location": {
      "title": "Neu anlegen",
      "tooltip": {
        "h": "Neu anlegen",
        "t": "Hier können Sie einen neuen Standort anlegen."
      }
    },
    "new_partner": {
      "title": "Neu anlegen",
      "tooltip": {
        "h": "Neu anlegen",
        "t": "Hier können sie einen neuen Geschäftspartner anlegen"
      }
    },
    "new_password": {
      "title": "Passwort",
      "tooltip": {
        "h": "Passwort ändern",
        "t": "Hier können Sie Ihr Passwort ändern."
      }
    },
    "no": {
      "title": "Nein",
      "tooltip": {
        "h": "Nein",
        "t": "Nein"
      }
    },
    "ok": {
      "title": "OK",
      "tooltip": {
        "h": "OK",
        "t": "OK"
      }
    },
    "openDetails": {
      "title": "Öffnen",
      "tooltip": {
        "h": "Öffnen",
        "t": "Detailansicht öffnen."
      }
    },
    "order": {
      "title": "Bestellen",
      "tooltip": {
        "h": "Bestellen",
        "t": "Ausgewählte Therapien bestellen."
      }
    },
    "patient_informed_consent_medication_pdf": {
      "title": "Vorlage Begleitmedikation",
      "tooltip": {
        "h": "Begleitmedikation",
        "t": "Vorlage PEE Begleitmedikation erstellen"
      }
    },
    "patient_informed_consent_pdf": {
      "title": "Vorlage DSGVO",
      "tooltip": {
        "h": "DSGVO",
        "t": "Vorlage PEE DSGVO erstellen"
      }
    },
    "print": {
      "title": "Drucken",
      "tooltip": {
        "h": "Drucken",
        "t": "Dokument drucken"
      }
    },
    "print_infusion_protocol": {
      "title": "Infusionsprotokoll",
      "tooltip": {
        "h": "Infusionsprotokoll drucken",
        "t": "Infusionsprotokoll drucken"
      }
    },
    "refresh": {
      "title": "Aktualisieren",
      "tooltip": {
        "h": "Aktualisieren",
        "t": "Daten aktualisieren"
      }
    },
    "register": {
      "title": "Registrierung abschließen",
      "tooltip": {
        "h": "Registrieren",
        "t": "Hier können Sie sich als Benutzer registrieren."
      }
    },
    "request": {
      "title": "Anfordern",
      "tooltip": {
        "h": "Neuvergabe anfordern",
        "t": "Hier können Sie die Neuvergabe des Passwortes verbindlich anfordern."
      }
    },
    "reset": {
      "title": "Zurücksetzen",
      "tooltip": {
        "h": "Zurücksetzen",
        "t": "Hier können Sie Ihre Eingabe zurücksetzen."
      }
    },
    "save": {
      "title": "Speichern",
      "tooltip": {
        "h": "Speichern",
        "t": "Hier können Sie Daten speichern."
      }
    },
    "save_and_close": {
      "label": "Schließen",
      "title": "Speichern und schließen",
      "tooltip": {
        "h": "Speichern und schließen",
        "t": "Hier können Sie Ihre Daten speichern und das Tab schließen, alles in einem Vorgang."
      }
    },
    "save_password": {
      "title": "Passwort übernehmen",
      "tooltip": {
        "h": "Neues Passwort speichern",
        "t": "Hier können Sie Ihr neues Passwort speichern."
      }
    },
    "send_again": {
      "title": "Erneut versenden",
      "tooltip": {
        "h": "Erneut versenden",
        "t": "E-Mail erneut versenden"
      }
    },
    "sendInvites": {
      "title": "Versenden",
      "tooltip": {
        "h": "Versenden",
        "t": "Erkannte E-Mail versenden"
      }
    },
    "sendSupport": {
      "title": "Senden",
      "tooltip": {
        "h": "Senden",
        "t": "Hier können Sie den Support senden"
      }
    },
    "share_therapy": {
      "title": "Übergabe",
      "tooltip": {
        "h": "Übergabe",
        "t": "Ausgewählte Therapien übergeben."
      }
    },
    "show_history": {
      "title": "Vitaldaten Historie",
      "tooltip": {
        "h": "Vitaldaten Verlauf",
        "t": "Hier können Sie die Vitaldaten Historie anzeigen"
      }
    },
    "submit": {
      "title": "Übernehmen",
      "tooltip": {
        "h": "Übernehmen",
        "t": "Hier können Sie Daten übernehmen."
      }
    },
    "understand": {
      "title": "Verstanden",
      "tooltip": {
        "t": "Verstanden"
      }
    },
    "update": {
      "title": "Aktualisieren",
      "tooltip": {
        "h": "Aktualisieren",
        "t": "Hier können Sie Daten neu abholen und die Seite aktualisieren."
      }
    },
    "use_as_template": {
      "title": "Als Vorlage benutzen",
      "tooltip": {
        "h": "Als Vorlage benutzen",
        "t": "Hier können Sie das Schema als Vorlage für ein neues Praxisschema nutzen."
      }
    },
    "use_existing_address": {
      "title": "Bestehende Adresse verwenden",
      "tooltip": {
        "h": "Bestehende Adresse verwenden",
        "t": "Hier können Sie die bestehenden Adresse verwenden."
      }
    },
    "use_existing_common_data": {
      "title": "Bestehende Grunddaten verwenden",
      "tooltip": {
        "h": "Bestehende Grunddaten verwenden",
        "t": "Hier können Sie die bestehenden Grunddaten verwenden."
      }
    },
    "use_existing_insurance_data": {
      "title": "Bestehende Versicherungsdaten verwenden",
      "tooltip": {
        "h": "Bestehende Versicherungsdaten verwenden",
        "t": "Hier können Sie die bestehenden Versicherungsdaten verwenden."
      }
    },
    "use_import_address": {
      "title": "Adresse aus Import übernehmen",
      "tooltip": {
        "h": "Neue Adresse übernehmen",
        "t": "Hier können Sie die neue Adresse übernehmen."
      }
    },
    "use_import_common_data": {
      "title": "Grunddaten aus Import übernehmen",
      "tooltip": {
        "h": "Neue Grunddaten übernehmen",
        "t": "Hier können Sie die neuen Grunddaten übernehmen."
      }
    },
    "use_import_insurance_data": {
      "title": "Versicherungsdaten aus Import übernehmen",
      "tooltip": {
        "h": "Neue Versicherungsdaten übernehmen",
        "t": "Hier können Sie die neuen Versicherungsdaten übernehmen."
      }
    },
    "yes": {
      "title": "Ja",
      "tooltip": {
        "h": "Ja",
        "t": "Ja"
      }
    }
  },
  "component_account": {
    "account_activity": {
      "account_data_header": "Account-Daten",
      "account_security_header": "Account-Sicherheit"
    },
    "email": "E-Mail",
    "email_placeholder": "E-Mail",
    "first_name": "Vorname",
    "first_name_placeholder": "Bitte geben Sie Ihren Vornamen ein.",
    "gender": "Anrede",
    "gender_placeholder": "Bitte wählen Sie Ihre Anrede aus.",
    "last_name": "Nachname",
    "last_name_placeholder": "Bitte geben Sie Ihren Nachnamen ein.",
    "login_name": "Benutzername",
    "login_name_placeholder": "Benutzername",
    "panels": {
      "account_security": "Accountaktionen",
      "account_security_sub_header": "Alle relevanten Einstellungen zur Accountsicherheit",
      "base_data": "Account",
      "base_data_sub_header": "Alle accountbezogenen Daten",
      "other_data": "Sonstiges",
      "other_data_sub_header": "Sonstige Einstellungen"
    },
    "placeholder_title": "Bitte wählen Sie Ihre Titel aus.",
    "preferred_location": "Bevorzugte Standortauswahl",
    "preferred_location_selection_placeholder": "Bevorzugte Standortauswahl beim Login",
    "successfully_saved": "Account erfolgreich gespeichert",
    "successfully_saved_header": "Gespeichert"
  },
  "component_address_data": {
    "address_line_1": "Zusatz",
    "address_line_1_placeholder": "Zusatz 1",
    "address_line_2": "Zusatz 2",
    "address_line_2_placeholder": "Zusatz 2",
    "city": "Stadt",
    "federal_state": "Bundesland",
    "header": {
      "text": "Adresse"
    },
    "number": "Hausnummer",
    "street": "Straße",
    "zip": "PLZ"
  },
  "component_agent_details": {
    "agent_search": "Wirkstoffsuche (Name, ATC-Code)",
    "application_forms": "Applikationsart (Mehrfachauswahl möglich)",
    "application_routes": "Applikationsweg (Mehrfachauswahl möglich)",
    "carrier_solutions": "Trägerlösung (Mehrfachauswahl möglich)",
    "category": "Kategorie",
    "check_application_form": "Applikationsart überprüfen",
    "check_application_route": "Applikationsweg überprüfen",
    "check_carrier_solution": "Trägerlösung überprüfen",
    "concentration_range_max": "Maximale Konzentration Zubereitung",
    "concentration_range_min": "Minimale Konzentration Zubereitung",
    "is_active": "Aktiv",
    "keyATC": "ATC-Code",
    "last_update_of_information": "Stand der Informationen",
    "name": "Name",
    "panels": {
      "application_data": "Daten für Wirkstoff-Applikation",
      "base_data": "Allgemein",
      "manufacturing_data": "Herstellungsdaten"
    },
    "successfully_edited": "Der Wirkstoff wurde erfolgreich bearbeitet.",
    "successfully_edited_header": "Bearbeitung erfolgreich",
    "successfully_saved": "Der Wirkstoff wurde erfolgreich gespeichert.",
    "successfully_saved_header": "Speicherung erfolgreich",
    "tabs": {
      "edit": "Wirkstoff",
      "new": "Wirkstoff (Neu)"
    },
    "total_volume_range_max": "Maximales Gesamtvolumen",
    "total_volume_range_min": "Minimales Gesamtvolumen",
    "units": "Dosierungstyp nach Fachinfo (Mehrfachauswahl möglich)"
  },
  "component_agent_list": {
    "category": "Kategorie",
    "is_inactive": "Inaktiv",
    "keyATC": "ATC-Code",
    "name": "Name",
    "show_all_items": "Inaktive anzeigen",
    "tabs": {
      "edit": "Wirkstoffe",
      "new": "Wirkstoff (Neu)"
    }
  },
  "component_blacklist": {
    "context_menu": {
      "remove_patient_from_blacklist": "Patient aus Sperrliste entfernen"
    },
    "date_of_birth": "Geburtsdatum",
    "first_name": "Vorname",
    "gender": "Geschlecht",
    "last_name": "Nachname",
    "patient_number": "AIS-ID",
    "searching": "Patient, Geburtsdatum, Versichertennummer, AIS-ID"
  },
  "component_confirm": {
    "cancel": "Nein",
    "ok": "Ja"
  },
  "component_current_vital_data": {
    "actual_date": "Stand Vitaldaten",
    "creatinine_clearance": "Kreatinin-Clearance",
    "current_date": "Aktuelle Vitaldaten",
    "height": "Größe",
    "skin_surface": "Körperoberfläche",
    "warning_no_vital_data": "Es sind keine Vitaldaten vorhanden.",
    "weight": "Gewicht"
  },
  "component_dashboard": {
    "hello": "Hallo",
    "manual": "Handbuch",
    "panels": {
      "user_data": {
        "header": "Benutzerdaten",
        "subheader": "Allgemeine Daten eines Nutzers"
      },
      "user_roles": {
        "header": "Benutzerrollen",
        "subheader": "Weisen Sie dem aktuellen Nutzer seine Rolle(n) zu"
      }
    },
    "planned": "überfällig",
    "salutation": "Hier sind Ihre Aufgaben für heute {day}, den {date}.",
    "support": "Support",
    "therapies": "Therapien",
    "today": "heute",
    "tomorrow": "morgen",
    "warning_exit_application": "Sie verlassen die Anwendung zu einer externen Website. Möchten Sie fortfahren?",
    "warning_exit_application_title": "Verlassen der Anwendung"
  },
  "component_details_contact_data": {
    "email": "E-Mail-Adresse",
    "mode": {
      "email": "E-Mail-Adresse",
      "fax": "Faxnummer",
      "mobile": "Handy-Nummer",
      "phone": "Telefonnummer"
    },
    "name": "Bezeichnung",
    "type": "Typ",
    "value": "Wert"
  },
  "component_email_confirm": {
    "back_to_login": "Zurück zum Login",
    "headline": "E-Mail-Änderung bestätigen",
    "password": "Passwort",
    "text": "Bitte geben Sie aus Sicherheitsgründen Ihr Passwort ein, wenn Sie Ihre E-Mail-Adresse ändern möchten."
  },
  "component_import_details": {
    "address": {
      "city": "Stadt",
      "number": "Hausnummer",
      "street": "Straße",
      "zip": "PLZ"
    },
    "checkboxes": {
      "no": "Nein",
      "yes": "Ja"
    },
    "date_accuracy": "Datumsgenauigkeit",
    "date_of_birth": "Geburtsdatum",
    "date_of_death": "Sterbedatum",
    "delivery_notes": "Lieferhinweise",
    "diagnosis_date": "Datum",
    "end_date_insurance_exemption": "befreit bis",
    "first_name": "Vorname(n)",
    "gender": "Geschlecht",
    "icd_code": "ICD-10 Code",
    "import_patient": "Patient importiert",
    "insurance_company": "Krankenkasse",
    "insurance_data_or": "oder",
    "insurance_number": "Versichertennummer",
    "insurance_state": "Versicherungsstatus",
    "is_active": "Patient aktiv",
    "is_exempt": "Zuzahlungsbefreit",
    "is_inactive": "Patient inaktiv",
    "last_name": "Name",
    "localization": "Seitenlokalisation",
    "message_address_existing_address": "Bestehende Adresse in TumorPrax:",
    "message_address_is_not_equal": "Die Adresse weicht von der bereits im System Vorhandenen in folgenden Feldern ab:",
    "message_common_data_are_not_equal": "Die Grunddaten weichen von den bereits im System vorhandenen Daten in folgenden Feldern ab",
    "message_insurance_data_are_not_equal": "Die Versicherungsdaten weichen von den bereits im System vorhandenen Daten in folgenden Feldern ab:",
    "name_prefix": "Namensvorsatz",
    "panels": {
      "address_data": "Anschrift",
      "address_data_sub_header": "Alle Adressdaten",
      "common_data": "Stammdaten",
      "common_data_sub_header": "Alle Personenbezogenen Daten",
      "diagnoses": "Diagnosen",
      "diagnoses_history": "Historie",
      "diagnoses_history_sub_header": "Bereits in TumorPrax vorhandene Diagnosen",
      "diagnoses_sub_header": "Alle gesicherten Diagnosen im Import",
      "insurance_data": "Krankenversicherungsdaten",
      "insurance_data_sub_header": "Alle Angaben zur Krankenversicherung des Patienten"
    },
    "patient_number": "AIS-ID",
    "patient_successfully_imported": "Der Patient wurde erfolgreich importiert",
    "replacement_code": "Ersatzcode",
    "show_all_diagnoses": "Alle Diagnosen",
    "show_tumor_diagnoses": "C/D Diagnosen",
    "start_date_insurance_exemption": "befreit ab",
    "subtitle": "Import",
    "title": "Titel",
    "tool_tip_insurance_state_others": "Ist der Patient weder gesetzlich noch privat versichert oder sind die Versichertenangaben unvollständig, ist einer der entsprechenden Ersatzcodes mit ergänzenden Informationen anzugeben.",
    "tool_tip_insurance_state_private": "Sollte das Institutionskennzeichen der privaten Kasse nicht bekannt sein, ist behelfsmäßig der Versichertenstatus \"sonstige\" unter Einsatz des entsprechenden Ersatzcodes zu verwenden."
  },
  "component_import_list": {
    "context_menu": {
      "add_patient_on_blacklist": "Zur Liste der gesperrter Patienten hinzufügen",
      "discard_patient_in_import": "Patient im aktuellen Import verwerfen",
      "edit_patient": "Patient bearbeiten"
    },
    "date_of_birth": "Geburtsdatum",
    "first_name": "Vorname",
    "gender": "Geschlecht",
    "last_modified": "Zuletzt bearbeitet",
    "last_name": "Nachname",
    "patient_number": "AIS-ID",
    "searching": "Patient, Geburtsdatum, Versichertennummer, AIS-ID",
    "successfully_saved": "Die Datei wurde erfolgreich importiert.",
    "successfully_saved_header": "Import erfolgreich",
    "tabs": {
      "blacklist_subtitle": "Liste aller gesperrter Patienten",
      "blacklist_title": "Gesperrte Patienten",
      "new": "Neuer Import"
    }
  },
  "component_infusion_list": {
    "ais_id": "AIS-ID",
    "application_date": "Applikationsdatum",
    "buttons": {
      "other_date": "Anderes Datum",
      "print": {
        "tooltip": {
          "h": "Drucken",
          "t": "ausgewählte Infusionsprotokolle drucken"
        }
      },
      "today": "Heute",
      "tomorrow": "Morgen",
      "tooltip": {
        "h": "Löschen",
        "t": "Eine oder mehrere Krankenkassen löschen"
      }
    },
    "context_menu": {
      "copy_infusion_plan": {
        "h": "Infusionsplan kopieren",
        "t": "Infusionsplan in Zwischenablage kopieren"
      },
      "copy_prescription": {
        "h": "Verordnung kopieren",
        "t": "Verordnung in Zwischenablage kopieren"
      },
      "open_patient": {
        "h": "Patient Öffnen",
        "t": "Den Patienten öffnen"
      },
      "open_schema": {
        "h": "Schema öffnen",
        "t": "Patientenschena öffnen"
      }
    },
    "cycle": "Zyklus",
    "date": "Datum",
    "day": "Tag",
    "first_name": "Vorname",
    "last_name": "Nachname",
    "missing_infusion_protocol": {
      "tooltip": {
        "h": "Infusionsprotokoll",
        "t": "Kein Infusionsprotokoll vorhanden"
      }
    },
    "patient_schema": "Patientenschema",
    "warning_header": "Warnung"
  },
  "component_insurance_company": {
    "confirm_delete_insuranceCompany": {
      "header": "kostenträger löschen",
      "text": "Sind Sie sich sicher, dass Sie den Kostenträger wirklich löschen möchten?"
    },
    "context_menu": {
      "delete_insurance_company": {
        "h": "Kostenträger löschen",
        "t": "Einen Kostenträger löschen"
      }
    },
    "federal_state": "Bundesland",
    "grid": {
      "ik": "IK-Nummer",
      "name": "Name"
    },
    "ik": "Kostenträger-IK",
    "name": "Name",
    "panels": {
      "insurance_company": {
        "header": "Kostenträger",
        "sub_header": "Krankenkassen/Krankenversicherungen"
      }
    },
    "searching": "Name, IK",
    "successfully_deleted": "Kostenträger wurde erfolgreich gelöscht.",
    "successfully_deleted_header": "Erfolgeich gelöscht",
    "successfully_saved": "Kostenträger wurde erfolgreich gespeichert.",
    "successfully_saved_header": "Speicherung erfolgreich",
    "tabs": {
      "edit": "Kostenträger",
      "new": "Neuer Kostenträger"
    },
    "warning_header": "Warnung"
  },
  "component_invitations_details": {
    "email": "E-Mail-Adresse",
    "first_name": "Vorname",
    "hint": "An dieser Stelle können Sie Einladungen an zukünftige Nutzer versenden, tragen Sie dazu einfach die gewünschte E-Mail in das Textfeld ein. Sie können auch mehrere E-Mails angeben und diese einfach mit einem Semikolon oder Komma getrennt eingeben. Abschließend drücken Sie noch den Button 'Versenden' und alle angegebenen Nutzer erhalten ihre Einladungs-E-Mail.",
    "hint2": "An dieser Stelle können Sie Einladungen an zukünftige Nutzer versenden, tragen Sie dazu einfach die gewünschte E-Mail in das Textfeld ein. Sie können auch mehrere E-Mails angeben und diese einfach mit einem Semikolon oder Komma getrennt eingeben z.B.: a{'@'}test.de ; b{'@'}test.de. Abschließend drücken Sie noch den Button Senden und alle angegebenen Nutzer erhalten ihre Einladungs-E-Mail.",
    "last_name": "Nachname",
    "location": "Standort",
    "location_chosen": "Standort ausgewählt",
    "location_not_chosen": "Standort nicht ausgewählt",
    "locations_and_roles": "Standort- / Rollenauswahl",
    "panels": {
      "emails": "E-Mail-Einladungen",
      "emails_subheader": "Einladung(en) per E-Mail versenden",
      "filtered_emails": "Versendete E-Mail-Adressen",
      "filtered_emails_subheader": "Eine Übersicht über den erfolgten oder abgebrochenen Versand jeder E-Mail",
      "recognized_emails": "Erkannte E-Mail-Addressen",
      "recognized_emails_subheader": "Um diesem(n) Nutzer(n) zusätzliche Informationen mitzugeben"
    },
    "placeholder_email": "z.B.: name{'@'}domain.de; name2{'@'}domain.de",
    "placeholder_first_name": "Vorname",
    "placeholder_last_name": "Nachname",
    "placeholder_salutation": "Anrede",
    "placeholder_title": "z.B. Dr.",
    "role_chosen": "Rolle ausgewählt",
    "role_not_chosen": "Rolle nicht ausgewählt",
    "roles": "Rollenauswahl",
    "salutation": "Anrede",
    "sent_canceled": "Versand abgebrochen",
    "sent_successful": "Versand erfolgreich",
    "successfully_saved": "E-Mail(s) erfolgreich versendet",
    "successfully_saved_header": "Versand erfolgreich",
    "text_role_choice": "Bitte wählen Sie mindestens eine Rolle in einem Standort aus.",
    "title": "Titel",
    "user_information": "Nutzerinformationen",
    "validation_email": "Eine oder mehrere E-Mail-Adressen sind ungültig.",
    "warning": "Einladung/en möglicherweise fehlerhaft",
    "warning_header": "Warnung"
  },
  "component_invitations_list": {
    "clock": "Uhr",
    "confirm_delete_header": "Einladung löschen",
    "confirm_delete_text": "Möchten Sie die Einladung ('{email}') wirklich löschen?",
    "confirm_extend_expire_header": "Gültigkeit verlängern",
    "confirm_extend_expire_text": "Möchten Sie die Gültigkeit von ('{email}') wirklich verlängern?",
    "created": "(Erstellt am)",
    "date_created": "Erstellt",
    "date_expired": "Gültig bis",
    "email": "E-Mail",
    "invite_type_root": "Vom ROOT eingeladen",
    "invite_type_user": "Von einem Mitarbeiter eingeladen",
    "location_names": "Standorte",
    "organisation": "Organisation",
    "read": "Gelesen",
    "running_out": "(Läuft ab)",
    "sent_again": "Erneut gesendet",
    "status": "E-Mail-Status",
    "successfully_deleted": "Einladung erfolgreich gelöscht",
    "successfully_deleted_header": "Einladung gelöscht",
    "successfully_expire_extended": "Gültigkeit erfolgreich verlängert",
    "successfully_expire_extended_header": "Gültigkeit verlängern",
    "tabs": {
      "new": "Einladung versenden"
    },
    "unread": "Ungelesen"
  },
  "component_location_details": {
    "additional_name": "Zusatzbezeichnung",
    "address": "Adresse",
    "alert_inactive_flag": "Der Standort kann nicht auf aktiv gesetzt werden, da es keine Standort-Administratoren (Benutzeradmins) gibt.",
    "alert_no_userAdmins": "Derzeit sind keine Standortadministratoren vorhanden.",
    "clock": "Uhr",
    "confirm_dialog": {
      "downgrade": {
        "header": "Downgrade des Standort",
        "text": "Der Standort  **{name}** wird nach der Bestätigung zu einer **Basis-Bestellung** heruntergestuft.##-br-##Alle zugehörende Benutzer verlieren Ihre Rollen."
      },
      "upgrade": {
        "header": "Upgrade des Standort",
        "text": "Der Standort **{name}** wird nach der Bestätigung zu einem **Arzt** heraufgestuft.##-br-##Alle zugehörende Benutzer verlieren Ihre Rollen."
      }
    },
    "copy_pin": "PIN kopieren",
    "display_name": "Bezeichnung",
    "email": "E-Mail",
    "existing_admins": "Bestehende Administratoren",
    "finalizer_details": {
      "days": "Tag(e)",
      "info_text": "Konfiguration, ob Therapien nach einer definierten Anzahl an Tagen nach dem Applikationsdatum automatisch als **Abgeschlossen** markiert werden sollen.+++ +++ Das betrifft alle Therapien mit einem Status größer gleich **Bestellt**.",
      "is_active": "Sollen Therapien automatisch als 'Abgeschlossen' markiert werden?",
      "retention_period": "Anzahl der Tage nach dem Applikationsdatum",
      "retention_period_placeholder": "1 bis 365"
    },
    "first_name": "Vorname",
    "header": "Standort",
    "header_new_location": "Neuer Standort: {location}",
    "header_users": "Mitarbeiterliste",
    "invite_new_user": "Neue Administratoren einladen",
    "is_active": "Standort-Zugriff für alle Nutzer deaktivieren?",
    "last_login": "Letzter Login",
    "last_name": "Name",
    "location_downgrade": {
      "title": "Downgrade",
      "tooltip": {
        "h": "Downgrade",
        "t": "Aktuellen Standort zu einer abgespeckten Basis-Bestellung herunterstufen."
      }
    },
    "location_successfully_changed": "Der Standort wurde erfolgreich geändert.",
    "location_successfully_changed_header": "Änderung gespeichert",
    "location_successfully_saved": "Der Standort wurde erfolgreich gespeichert.",
    "location_successfully_saved_header": "Standort gespeichert",
    "location_successfully_update_type": "Der Standorttyp wurde erfolgreich geändert.",
    "location_successfully_update_type_header": "Standorttyp geändert",
    "location_upgrade": {
      "title": "Upgrade",
      "tooltip": {
        "h": "Upgrade",
        "t": "Aktuellen Standort zu einem vollwertigen Arzt hochstufen."
      }
    },
    "login_name": "Login-Name",
    "panels": {
      "finalizer_details": {
        "header": "Automatisches Verschieben von Therapien",
        "subheader": "Konfiguration der Automatisierung des Abschliessens von Therapien"
      },
      "location_admins": {
        "header": "Standortadministratoren",
        "subheader": "Laden Sie neue Nutzer als Administrator ein oder verwalten Sie bestehende"
      },
      "location_data": {
        "header": "Standortdaten",
        "subheader": "Anzeige allgemeiner Standortdaten"
      },
      "opening_hours": {
        "header": "Öffnungszeiten"
      },
      "user_roles": {
        "header": "Mitarbeiter",
        "subheader": "Weisen Sie den Mitarbeitern Rollen zu"
      }
    },
    "pin": "PIN",
    "role_not_selected": "Rolle nicht ausgewählt",
    "role_selected": "Rolle ausgewählt",
    "roles_successfully_saved": "Die Rollen wurden erfolgreich geändert.",
    "roles_successfully_saved_header": "Rollen geändert",
    "send_invitation": "Einladung versenden",
    "successfully_saved": "E-Mail(s) erfolgreich versendet",
    "successfully_saved_header": "Versand erfolgreich",
    "support_email": "Support-E-Mail",
    "support_email_placeholder": "Support-E-Mail für wichtige Fragen",
    "support_phone": "Support-Telefon",
    "support_phone_placeholder": "Support-Telefonnummer für wichtige Fragen",
    "tabs": {
      "details": {
        "header": "Details"
      },
      "users": {
        "header": "Mitarbeiter"
      }
    },
    "title": "Titel",
    "type": "Art der Einrichtung",
    "user": "Mitarbeiter",
    "user_name": "Name des Users",
    "warning": "Einladung/en möglicherweise fehlerhaft",
    "warning_header": "Warnung"
  },
  "component_location_list": {
    "address": "Adresse",
    "created_by": "Erstellt durch",
    "delete_location": "Standort löschen",
    "display_name": "Name",
    "do_you_want_to_delete_location": "Möchten Sie die Einrichtung {name} wirklich löschen. Ein Wiederherstellen ist danach nicht mehr möglich.",
    "inactive_tooltip_text": "Dieser Standort ist inaktiv oder es sind noch keine Administratoren verlinkt.",
    "is_active": "Aktiv",
    "location_renderer": {
      "address": "Adresse",
      "city": "Stadt",
      "email": "E-Mail",
      "is_active": "Aktivität",
      "line1": "Zeile 1",
      "line2": "Zeile 2",
      "phone": "Telefon",
      "street": "Straße, Nr.",
      "support": "Support",
      "zip": "PLZ"
    },
    "location_successfully_deleted": "Einrichtung wurde erfolgreich gelöscht",
    "location_type": "Typ",
    "name": "Name",
    "new_location": {
      "title": "Neuer Standort",
      "tooltip": {
        "h": "Neuer Standort",
        "t": "Hier können Sie Inaktive ein- und ausblenden."
      }
    },
    "new_location_tab": "Neuer Standort",
    "partner_type": "Partnertyp",
    "pin": "PIN",
    "subtitle": "Standort",
    "support": "Support",
    "tabs": {
      "new": "Standort (Neu)"
    }
  },
  "component_login": {
    "application": "TumorPrax",
    "authentification": "Authentifizierung",
    "back_to_login": "Zurück zum Login",
    "choose_location": "Standort auswählen",
    "login": "E-Mail-Adresse oder Benutzername",
    "login_page_header": "Login",
    "login_text": "Bitte melden Sie sich mit Ihrer E-Mail-Adresse oder Ihrem Benutzernamen an.",
    "password": "Passwort",
    "password_forgot": "Passwort vergessen",
    "two_factor": "Zweifaktor",
    "two_factor_input_text": "Sie haben zur Eingabe noch",
    "two_factor_input_text2": "Zeit, bevor sie aus Sicherheitsgründen zum Login zurückgeleitet werden!",
    "two_factor_input_time": "Sekunden",
    "two_factor_text": "Bitte tragen Sie den aktuellen Zugriffscode aus Ihrer Authentikator-App in das unten stehende Feld ein und bestätigen die Eingabe.",
    "welcome": "Herzlich Willkommen"
  },
  "component_lx_two_fa_code_input": {
    "empty_hint_1": "Bitte Backup-Code eingeben",
    "empty_hint_2": "Bitte Auth-Code eingeben",
    "link": "hier",
    "text_1": "Falls Sie Ihre App nicht zur Verfügung haben, klicken Sie bitte",
    "text_2": "für die Eingabe eines Backup-Codes.",
    "text_3": "Falls Sie Ihre App zur Verfügung haben, klicken Sie bitte",
    "text_4": "für die Eingabe eines Zugriffscodes."
  },
  "component_mapping_agent_details": {
    "application_forms": "Applikationsart",
    "application_routes": "Applikationsweg",
    "carrier_solutions": "Trägerlösung",
    "category": "Kategorie",
    "concentration_range_max": "Maximale Konzentration Zubereitung",
    "concentration_range_min": "Minimale Konzentration Zubereitung",
    "is_active": "Aktiv",
    "keyATC": "ATC-Code",
    "last_update_of_information": "Stand der Informationen",
    "name": "Name",
    "panels": {
      "application_data": "Daten für Wirkstoff-Applikation",
      "base_data": "Allgemein",
      "manufacturing_data": "Herstellungsdaten"
    },
    "tabs": {
      "display": "Wirkstoff"
    },
    "total_volume_range_max": "Maximales Gesamtvolumen",
    "total_volume_range_min": "Minimales Gesamtvolumen",
    "units": "Dosierungstyp nach Fachinfo"
  },
  "component_mapping_agent_list": {
    "carrier_solutions": "Trägerlösungen",
    "category": "Kategorie",
    "is_inactive": "Inaktiv",
    "is_inactive_hint": "Dieser Wirkstoff ist inaktiv",
    "keyATC": "ATC-Code",
    "name": "Name",
    "no": "Nein",
    "show_all_items": "Inaktive anzeigen",
    "tabs": {
      "display": "Wirkstoffe"
    },
    "yes": "Ja"
  },
  "component_master_schema_details": {
    "agents": "Wirkstoff",
    "alternative_name": "Alternativname",
    "application_form": "Applikationsart",
    "application_route": "Applikationsweg",
    "carrier_solution": "Trägerlösung",
    "concomitant_agents": "Begleitmedikation",
    "day": "Tag",
    "dialog_title": "Infusionsprotokoll drucken",
    "dosage": "Dosierung",
    "error_no_application_route_abbreviation": "Wert nicht gefunden",
    "icd": "ICD-10",
    "icd_list": "ICD-10-Liste",
    "indication": "Indikation",
    "infusion_duration": "Infusionsdauer",
    "infusion_protocol": "Infusionsprotokollvorlage",
    "initial_dosage": "Initialdosierung",
    "is_active": "Aktiv",
    "length_of_cycle": "Zyklusdauer (in Tagen)",
    "master_schema_infusion_protocol_warning": "Es wurden neue Substanzen/Medikationen hinzugefügt. Bitte kontrollieren Sie die Infusionsprotokollvorlage.",
    "master_schema_not_complete": "Dieses Masterschema befindet sich in Überarbeitung.",
    "master_schema_not_complete_plural": "Mehrere Masterschemen befinden sich in Überarbeitung.",
    "name": "Name",
    "number_of_cycles": "Anzahl Zyklen",
    "oral_agents": "Orale Substanzen",
    "panels": {
      "agents": "Substanzen",
      "base_data": "Allgemein",
      "carrier_solutions": "Wässerung",
      "concomitant_agents": "Begleitmedikation",
      "cycles": "Zyklen",
      "oral_agents": "Orale Substanzen",
      "proprietary_agents": "Prä- und Postmedikation"
    },
    "proprietary_agents": "Prä- und Postmedikation",
    "scheduling_duration": "Zeitlicher Ablauf",
    "selected": "(ausgewählt)",
    "successfully_saved": "Masterschema wurde erfolgreich gespeichert",
    "successfully_saved_header": "Speicherung erfolgreich",
    "tabs": {
      "display": "Masterschema"
    },
    "taking_types": {
      "evening": "abends",
      "morning": "früh",
      "night": "nachts",
      "noon": "mittags"
    },
    "takings": "Einnahme",
    "title_dialog": " Infusionsprotokoll drucken",
    "top_category": "(Oberkategorie)",
    "total_volume": "Gesamtvolumen",
    "volume": "Volumen"
  },
  "component_master_schema_list": {
    "alternative_name": "Alternativname",
    "icd": "ICD-10",
    "infusion_protocol": "Infusionsprotokollvorlage",
    "infusion_protocol_hint": "Infusionsprotokollvorlage ist vorhanden",
    "infusion_protocol_tooltip": "Infusionsprotokollvorlage ist vorhanden",
    "is_inactive": "Inaktiv",
    "is_inactive_tooltip": "Masterschema ist inaktiv",
    "length_of_cycle": "Zyklusdauer",
    "name": "Name",
    "number_of_cycles": "Anzahl Zyklen",
    "show_all_items": "Inaktive anzeigen",
    "tabs": {
      "display": "Masterschemen"
    }
  },
  "component_my_location": {
    "additional_name": "Zusatzbezeichnung",
    "address": "Adressdaten",
    "base_data": "Grunddaten",
    "buttons": {
      "copy_pin": "PIN kopieren"
    },
    "display_name": "Name",
    "email": "E-Mail",
    "first_name": "Vorname",
    "last_name": "Nachname",
    "overview": "Übersicht",
    "panels": {
      "contact_data": {
        "header": "Kontaktdaten"
      },
      "general_data": {
        "header": "Stammdaten",
        "sub_header": "Alle standortbezogenen Daten"
      },
      "office_hours": {
        "header": "Öffnungszeiten",
        "subheader": "Alle Angaben zu täglichen Zeitfenstern und Ruhetage"
      }
    },
    "phone": "Telefonnummer",
    "pin": "PIN",
    "successfully_saved": "Stammdaten erfolgreich gespeichert",
    "successfully_saved_header": "Speicherung erfolgreich",
    "title": "Titel"
  },
  "component_new_password": {
    "back_to_login": "Zurück zum Login",
    "headline": "Passwort Neuvergabe",
    "password": "Passwort",
    "password2": "Passwort (Wiederholung)",
    "successfully_saved": "Das Passwort wurde erfolgreich geändert.",
    "successfully_saved_header": "Speicherung erfolgreich",
    "text": "Um Ihr altes Passwort zurückzusetzen und ein neues zu vergeben, tragen Sie bitte Ihr neues Passwort in die oben stehenden Felder ein und bestätigen Sie Ihre Eingabe."
  },
  "component_partner_details": {
    "buttons": {
      "more_delivery_addresses": "Weitere Lieferadressen",
      "pin_search": "Per PIN suchen"
    },
    "contact_name": "Ansprechpartner",
    "contact_person": "Ansprechpartner",
    "email": "E-Mail",
    "is_active": "Geschäftspartner für die Auswahl sperren?",
    "name": "Name",
    "panels": {
      "address": {
        "header": "Adresse"
      },
      "contact_details": {
        "header": "Kontaktdaten"
      },
      "general": {
        "header": "Allgemein",
        "sub_header": "Alle Grunddaten und Adresse zum Geschäftspartner"
      },
      "opening_hours": {
        "header": "Öffnungszeiten"
      }
    },
    "phone": "Telefonnummer",
    "phone_alternate": "Telefonnummer (alternativ)",
    "phone_mobile": "Telefon mobil",
    "pin": "PIN",
    "successfully_saved": "Geschäftspartner erfolgreich gespeichert",
    "successfully_saved_header": "Speicherung erfolgreich",
    "tabs": {
      "new": "Neuer Geschäftspartner",
      "subtitle": "Geschäftspartner"
    },
    "title": "Titel",
    "type": "Typ"
  },
  "component_partner_list": {
    "grid": {
      "is_active": "Aktiv",
      "is_inactive": "Inaktiv",
      "is_inactive_tooltip_text": "Partner ist inaktiv",
      "name": "Name",
      "type": "Partnertyp"
    },
    "navigation": {
      "new_basic_order": "Neue Basisbestellung anlegen",
      "new_pharmacy": "Neue Apotheke anlegen",
      "new_physician": "Neuen Arzt anlegen",
      "pharmacy_per_pin": "Apotheke per PIN suchen",
      "physician_per_pin": "Vertretungsarzt per PIN suchen"
    }
  },
  "component_password_forgot": {
    "back_to_login": "Zurück zum Login",
    "headline": "Passwort vergessen",
    "login": "E-Mail oder Benutzername",
    "or": "oder",
    "successfully_saved": "Eine E-Mail wurde erfolgreich versendet.",
    "successfully_saved_header": "Passwort anfordern erfolgreich",
    "text1": "Um das Zurücksetzen Ihres Passworts zu veranlassen, tragen Sie dafür bitte Ihren Benutzernamen ",
    "text2": "Ihre E-Mail Adresse in das untenstehende Feld ein und klicken Sie den Button \"Anfordern\". Im Anschluss erhalten Sie eine E-Mail mit der Möglichkeit zum Zurücksetzen Ihres Passworts."
  },
  "component_patient_common_data": {
    "alerts": {
      "duplicate_patient": "Patienten mit diesen Stammdaten und/oder dieser Versicherungsnummer existeren bereits:"
    },
    "buttons": {
      "add_contact": {
        "title": "Kontakt hinzufügen",
        "tooltip": {
          "h": "Hinzufügen",
          "t": "Kontakt hinzufügen"
        }
      },
      "ignore": "Ignorieren",
      "new_memo": "Neue Notiz hinzufügen"
    },
    "clock": "Uhr",
    "confirm": "Bestätigung",
    "contact_types": {
      "email": "E-Mail-Adresse",
      "fax": "Faxnummer",
      "mobile": "Handy-Nummer",
      "phone": "Telefonnummer"
    },
    "created": "Erstellt von",
    "date_of_birth": "Geburtsdatum",
    "date_of_death": "Sterbedatum",
    "delivery_notes": "Lieferhinweise",
    "email": "E-Mail",
    "end_date_insurance_exemption": "befreit bis",
    "first_name": "Vorname(n)",
    "gender": "Geschlecht",
    "insurance_company": "Krankenkasse",
    "insurance_data_or": "oder",
    "insurance_number": "Versichertennummer",
    "insurance_state": "Versicherungsstatus",
    "is_exempt": "Zuzahlungsbefreit",
    "is_inactive": "Patient in der Patientenübersicht ausblenden?",
    "last_name": "Name",
    "name_prefix": "Namensvorsatz",
    "panels": {
      "address_data": "Anschrift",
      "common_data": "Stammdaten",
      "contact_data": {
        "header": "Kontaktdaten",
        "header_empty": "Kontaktdaten hinzufügen",
        "sub_header": "Alle Angaben zu den Kontaktdaten"
      },
      "insurance_data": "Krankenversicherungsdaten",
      "insurance_data_sub_header": "Alle Angaben zur Krankenversicherung des Patienten",
      "memos": "Notizen",
      "memos_sub_header": "Alle relevanten Notizen zum Patienten"
    },
    "patient_comment": "Bemerkung",
    "patient_death_cancel_therapies": "Der Patient ist verstorben, es werden alle offenen Patientenschemen beendet. Möchten Sie zusätzlich noch alle offenen Therapien abbrechen?",
    "patient_number": "AIS-ID",
    "patient_successfully_changed": "Der Patient wurde erfolgreich geändert",
    "patient_successfully_saved": "Der Patient wurde erfolgreich gespeichert",
    "phone": "Telefonnummer",
    "phone_alternative": "Telefonnummer (alternativ)",
    "replacement_code": "Ersatzcode",
    "save_patient": "Patient gespeichert",
    "start_date_insurance_exemption": "befreit ab",
    "text": "Text",
    "timestamp": "Datum",
    "title": "Titel",
    "tool_tip_insurance_state_others": "Ist der Patient weder gesetzlich noch privat versichert oder sind die Versichertenangaben unvollständig, ist einer der entsprechenden Ersatzcodes mit ergänzenden Informationen anzugeben.",
    "tool_tip_insurance_state_private": "Sollte das Institutionskennzeichen der privaten Kasse nicht bekannt sein, ist behelfsmäßig der Versichertenstatus \"sonstige\" unter Einsatz des entsprechenden Ersatzcodes zu verwenden."
  },
  "component_patient_details": {
    "common_data": "Stammdaten",
    "diseases": "Krankheiten",
    "unsaved_data_message": "Der Bereich \"{tab}\" hat noch ungespeicherte Daten. Wollen Sie wirklich fortfahren. Alle gemachten Änderungen gehen dabei verloren.",
    "unsaved_data_message_header": "Tabwechsel/Speichervorgang",
    "vital_data": "Vitaldaten"
  },
  "component_patient_diseases_data": {
    "buttons": {
      "concomitant_disease": "Neue Begleiterkrankung",
      "new_diagnosis": "Neue Diagnose"
    },
    "diagnosis_date": "Diagnosedatum",
    "diagnosis_side_localization": "Seitenlokalisation",
    "diagnosis_text": "Diagnosetext",
    "diagnosis_version": "Version",
    "icd_code_diagnostic_assurance": "Diagnosesicherung",
    "panels": {
      "concomitant_diseases": "Begleit- und Nebenerkrankungen",
      "concomitant_diseases_sub_header": "Alle bekannten Begleiterkrankungen",
      "diagnoses": "Diagnosen",
      "diagnoses_sub_header": "Alle therapierelevanten Diagnosen"
    },
    "unknown_diagnosis_date": "(unbekannt)"
  },
  "component_patient_documents": {
    "confirm_delete": "Möchten Sie die ausgewählte Datei wirklich löschen?",
    "confirm_delete_header": "Datei löschen",
    "document_type": "Dokumententyp",
    "document_types": {
      "patient": "Sonstiges",
      "patient_informed_consent": "PEE DSGVO",
      "patient_informed_consent_medication": "PEE Begleitmedikation"
    },
    "drop_description": "Ziehen Sie die Datei auf diesen Bereich oder drücken Sie den unten stehenden Button.",
    "panels": {
      "documents": "Dokumente",
      "patient_consent_form": "Patienteneinverständniserklärungen (PEE)"
    },
    "patient_informed_consent": "PEE DSGVO",
    "patient_informed_consent_medication": "PEE Begleitmedikation",
    "successfully_deleted": "Datei wurde erfolgreich gelöscht",
    "successfully_deleted_header": "Löschung erfolgreich",
    "table": {
      "document_type": "Dokumententyp",
      "file_name": "Dateiname",
      "file_size": "Dateigröße",
      "file_type": "Dateityp",
      "uploaded": "Hochgeladen am"
    },
    "tabs": {
      "display_consent": "Patienteneinverständniserklärung",
      "display_consent_medication": "PEE Begleitmedikation"
    },
    "uploaded_files": "Hochgeladene Dateien"
  },
  "component_patient_documents_basic_order": {
    "confirm_delete": "Möchten Sie die ausgewählte Datei wirklich löschen?",
    "confirm_delete_header": "Datei löschen",
    "document_type": "Dokumententyp",
    "document_types": {
      "patient_informed_consent": "PEE DSGVO"
    },
    "drop_description": "Ziehen Sie die Datei auf diesen Bereich oder drücken Sie den unten stehenden Button.",
    "panels": {
      "documents": "Dokumente",
      "patient_consent_form": "Patienteneinverständniserklärungen (PEE)"
    },
    "patient_informed_consent": "PEE DSGVO",
    "patient_informed_consent_medication": "PEE Begleitmedikation",
    "successfully_deleted": "Datei wurde erfolgreich gelöscht",
    "successfully_deleted_header": "Löschung erfolgreich",
    "table": {
      "document_type": "Dokumententyp",
      "file_name": "Dateiname",
      "file_size": "Dateigröße",
      "file_type": "Dateityp",
      "uploaded": "Hochgeladen am"
    },
    "tabs": {
      "display_consent": "Patienteneinverständniserklärung",
      "display_consent_medication": "PEE Begleitmedikation"
    },
    "uploaded_files": "Hochgeladene Dateien"
  },
  "component_patient_info": {
    "ais_id": "AIS-ID",
    "date_of_birth": "Geburtsdatum",
    "date_of_death": "Sterbedatum",
    "gender": "Geschlecht",
    "hint": "Mit einem Mausklick auf dieses Feld, können Sie direkt zu den Patientendetails gelangen.",
    "text_death_patient": "Patient ist verstorben"
  },
  "component_patient_list": {
    "basic_order_states": {
      "approved": "Freigegeben",
      "created": "Erstellt",
      "ordered": "Bestellt",
      "undefined": ""
    },
    "confirm_delete_patient": {
      "header": "Patient löschen",
      "text": "Möchten Sie den ausgewählten Patienten **({name})** wirklich löschen?"
    },
    "context_menu": {
      "delete_patient": {
        "h": "Patient löschen",
        "t": "Den Patienten löschen"
      }
    },
    "date_of_birth": "Geburtsdatum",
    "date_of_death": "Sterbedatum",
    "failed_deleted_header": "Löschung fehlgeschlagen",
    "first_name": "Vorname",
    "gender": "Geschlecht",
    "insurance_company": "Krankenkasse",
    "insurance_number": "Versichertennummer",
    "is_dead": "Verstorben",
    "is_dead_tooltip_text": "Patient ist am {date_of_death} verstorben",
    "is_inactive": "Inaktiv",
    "is_inactive_tooltip_text": "Patient ist inaktiv",
    "last_modified": "Zuletzt bearbeitet",
    "last_name": "Nachname",
    "order_status": "Status Anforderung",
    "patient_number": "AIS-ID",
    "searching": "Patient, Geburtsdatum, Versichertennummer, AIS-ID",
    "show_all_items": "Inaktive anzeigen",
    "successfully_deleted": "Patient erfolgreich gelöscht.",
    "successfully_deleted_header": "Löschung erfolgreich",
    "tabs": {
      "new": "Neuer Patient"
    }
  },
  "component_patient_list_basic_order": {
    "searching": "Patient, Geburtsdatum, Versichertennummer"
  },
  "component_patient_patient_schema_list": {
    "alternative_name": "Alternativname",
    "closed": "Beendet",
    "closed_tooltip": "Patientenschema wurde beendet",
    "confirm_delete_patient_schema": "Möchten Sie das ausgewählte Patientenschema wirklich löschen?",
    "confirmation": "Bestätigung",
    "context_menu": {
      "delete_patient_schema": {
        "h": "Patientenschema löschen",
        "t": "Das Patientenschema löschen"
      }
    },
    "cycle_start": "Startzyklus",
    "date_start": "Startdatum",
    "length_of_cycle": "Zyklusdauer (Tage)",
    "name": "Name",
    "new_tooltip": "Patientenschema hat noch keine geplanten Therapien",
    "number_of_cycles": "Anzahl Zyklen",
    "patient_schema": "Patientenschema: ",
    "schema_closed": "Schema beendet: ",
    "successfully_deleted_header": "Löschung erfolgreich",
    "successfully_deleted_patient_schema": "Patientenschema erfolgreich gelöscht.",
    "tabs": {
      "edit": "Patientenschema bearbeiten"
    },
    "warning_header": "Warnung"
  },
  "component_patient_schema_detail": {
    "tab_header_details": "Details",
    "tab_header_therapy_plan": "Therapieplanung"
  },
  "component_patient_schema_details": {
    "add": " hinzufügen",
    "add_cycle_therapies": "Substanzen hinzufügen",
    "add_vital_data": "Vitaldaten hinzufügen",
    "alternative_name": "Alternativname",
    "approve_vital_data": "Vitaldaten bestätigen",
    "buttons": {
      "btn_delete_details": {
        "tooltip": {
          "h": "Details löschen",
          "t": "Details löschen"
        }
      },
      "btn_delete_patient_schema": {
        "tooltip": {
          "h": "Patientenschema löschen",
          "t": "Das Patientenschema löschen"
        }
      }
    },
    "confirm_delete": "Möchten Sie das ausgewählte Patientenschema wirklich löschen?",
    "confirm_delete_header": "Patientenschema löschen",
    "context_menu": {
      "create_praxis_schema": {
        "h": "Als Vorlage für Praxisschema benutzen",
        "t": "Hier können Sie das Schema als Vorlage für ein neues Praxisschema nutzen."
      },
      "description": "Weitere Aktionen: Praxisschema erstellen",
      "title": "Weitere Aktionen"
    },
    "cycle_start": "Startzyklus",
    "date_start": "Startdatum",
    "delivery_notes": "Lieferhinweise",
    "diagnosis": "Diagnose",
    "error_deleting_data": "Fehler beim Löschen der Daten.",
    "indication": "Indikation",
    "length_of_cycle": "Zykluslänge (in Tagen)",
    "message_failed_create_therapies_multi": "{count} Therapien konnten nicht erstellt werden.",
    "message_failed_create_therapies_single": "{count} Therapie konnte nicht erstellt werden.",
    "message_failed_delete_patient_schema": "Das Patientenschema kann nicht gelöscht werden, da für dieses noch Therapien existieren.",
    "message_no_therapies_created": "Es konnten keine Therapien erstellt werden, weil sich alle berechneten Applikationstage in der Vergangenheit befinden.",
    "message_no_therapies_created_new_vital_data": "Es konnten keine Therapien erstellt werden, da sich die Vitaldaten zwischenzeitlich geändert haben.",
    "message_no_therapies_created_title": "Keine Therapien erstellt",
    "message_schema_is_migrated": "Dies ist ein migriertes Patientenschema und kann Aufgrund von unvollständigen Daten nicht kopiert werden.",
    "name": "Name",
    "panels": {
      "carrier_solutions": "Wässerung",
      "concomitant_therapies": "Begleitmedikation",
      "cycles": "Zyklen",
      "general_data": "Allgemein",
      "oral_therapies": "Orale Substanzen",
      "proprietary_therapies": "Prä- und Postmedikation",
      "therapies": "Substanzen"
    },
    "patient": "Patient",
    "patient_schema": "Patientenschema: ",
    "patient_schema_successfully_changed": "Das Patientenschema wurde erfolgreich geändert",
    "patient_schema_successfully_saved": "Das Patientenschema wurde erfolgreich gespeichert",
    "save_patient_schema": "Patientenschema gespeichert",
    "start": "Uhrzeit",
    "successfully_deleted_header": "Löschung erfolgreich",
    "successfully_deleted_patient_details": "Details wurden erfolgreich gelöscht",
    "successfully_deleted_patient_schema": "Patientenschema erfolgreich gelöscht.",
    "tabs": {
      "new": "Neues Patientenschema"
    },
    "therapy_goal_type": "Therapieziel",
    "therapy_line_type": "Therapielinie",
    "therapy_type_type": "Therapieart",
    "tooltip": {
      "add_cycles": {
        "h": "Zyklen hinzufügen",
        "t": "Hier können sie Zyklen hinzufügen"
      },
      "add_cycles_disabled": {
        "h": "Zyklen hinzufügen",
        "t": "Zyklen können nicht hinzugefügt werden, da für den letzten Detail noch keine Therapien erstellt wurden."
      },
      "close_patient_schema": {
        "h": "Patientenschema beenden",
        "t": "Hier können sie das Patientenschema beenden"
      },
      "postpone_therapies": {
        "h": "Therapien verschieben",
        "t": "Hier können sie Therapien durch Anpassung der Zykluslänge verschieben."
      }
    },
    "warning_carboplatin_schema_missing_creatinine_clearance": "Dies ist ein Carboplatin-Schema und es fehlen die Kreatinin-Clearance Werte.",
    "warning_header": "Warnung",
    "warning_new_schema_approve_vital_data": "Dies ist ein neues Therapieschema für den Patienten mit relativen Dosierungen. Sind diese Vitaldaten noch aktuell?",
    "warning_no_vital_data": "Es sind keine Vitaldaten vorhanden.",
    "warning_not_owner_of_schema": "Dies ist ein Patientenschema eines anderen Standortes.",
    "warning_schema_created_by_pharmacy": "Das Patientenschema wurde von einer Apotheke angelegt und kann nicht weiter fortgeführt werden (Zyklen hinzufügen).",
    "warning_schema_has_no_cycle_therapies": "Dieses Patientenschema hat keine Substanzen und kann daher keine Therapien erstellen.",
    "warning_schema_is_closed": "Das Patientenschema wurde beendet.",
    "warning_vital_data_needed": "Es werden Vitaldaten für die Therapieberechnung benötigt.",
    "warning_vital_data_too_old": "Die Vitaldaten sind über 3 Monate alt. Sind diese noch aktuell?"
  },
  "component_patient_schema_therapy_plan": {
    "add_vital_data": "Vitaldaten hinzufügen",
    "agent": "Wirkstoff",
    "application_date": "Applikationsdatum",
    "approve_vital_data": "Vitaldaten bestätigen",
    "break": "Verschiebung",
    "break_details": "(Details: {idx}, Zykluslänge: {duration})",
    "break_successfully_deleted": "Die Verschiebung wurde erfolgreich gelöscht.",
    "breaks": "Verschiebung(en)",
    "cancel_therapy_confirmation": "Sollen die Therapien wirklich abgesagt werden?",
    "carrier_solution": "Trägerlösung",
    "close_date": "Ende Datum",
    "close_reason": "Grund",
    "collapse_empty_cycles": "Leere Zyklen ausblenden",
    "confirm_set_status_to_canceled": "Möchten Sie die {count} Therapien wirklich absagen?",
    "confirmation": "Bestätigung",
    "context_menu": {
      "cancel_therapies": {
        "h": "Therapien absagen",
        "t": "Die ausgewählten Therapien absagen."
      },
      "delete_selected_therapies": {
        "h": "Therapien löschen",
        "t": "Die ausgewählten Therapien löschen."
      },
      "delete_therapy": {
        "h": "Therapie löschen",
        "t": "Die Therapie löschen."
      },
      "dosage_reduction": {
        "h": "Dosisreduktion in %",
        "t": "Dosisreduktion für die ausgewählten Therapien setzen."
      },
      "order_therapies": {
        "h": "Therapien bestellen",
        "t": "Die ausgewählten Therapien bestellen."
      },
      "postpone_therapy": {
        "h": "Therapien verschieben",
        "t": "Die Therapie verschieben."
      }
    },
    "context_menu_therapies": {
      "description": "Weitere Aktionen: Löschen, Dosisreduktion",
      "title": "Weitere Aktionen"
    },
    "created_from": "Erstellt von",
    "cycle": "Zyklus",
    "cycle_successfully_deleted": "Der Zyklus wurde erfolgreich gelöscht.",
    "date": "Datum",
    "date_first_dosage": "Datum erste Gabe",
    "day": "Tag",
    "death": "Verstorben",
    "delete_break": "Verschiebung gelöscht",
    "delete_cycle": "Zyklus gelöscht",
    "delete_last_cycle": "Letzten Zyklus löschen",
    "delete_last_cycle_confirmation": "Soll der letzte Zyklus wirklich gelöscht werden?",
    "delete_schema_break_confirmation": "Soll die Verschiebung wirklich gelöscht werden?",
    "delete_therapy": "Therapie gelöscht",
    "delete_therapy_confirmation": "Sollen die Therapien wirklich gelöscht werden?",
    "delete_therapy_confirmation_single": "Soll die Therapie wirklich gelöscht werden?",
    "deleted_therapies": "gelöschte Therapie(n)",
    "deleted_therapies_to_restore": "gelöschte Therapie(n) zur Wiederherstellung",
    "description": "Bemerkungen",
    "dosage": "Dosis",
    "duration": "Dauer",
    "holiday": "Praxisurlaub",
    "message_failed_deleted": "Anzahl nicht gelöschter Therapien: {count}",
    "message_failed_dosage_reduction": "Anzahl nicht aktualisierter Therapien: {count}",
    "message_failed_order_therapies": "Die Therapien konnten nicht bestellt werden.",
    "message_failed_order_therapies_multi": "{count} Therapien konnten nicht freigegeben werden.",
    "message_failed_order_therapies_single": "{count} Therapie konnte nicht freigegeben werden.",
    "message_failed_set_status_therapies_multi": "Der Status von {count} Therapien konnte nicht gesetzt werden.",
    "message_failed_set_status_therapies_single": "Der Status von {count} Therapie konnte nicht gesetzt werden.",
    "message_no_selected_therapy_can_be_deleted": "Keine der ausgewählten Therapien kann gelöscht werden.",
    "message_no_selected_therapy_can_be_updated": "Keine der ausgewählten Therapien kann geändert werden.",
    "message_password_required": "Das Passwort wird benötigt.",
    "message_wrong_password": "Das eingegebene Passwort ist falsch.",
    "open_infusion_protocol": "Infusionsprotokollvorlage öffnen",
    "panels": {
      "schema_result": "Ergebnis der Therapie",
      "therapy_plan": "Therapieplan"
    },
    "partner": "Partner",
    "patient_schema_successfully_changed": "Das Patientenschema wurde erfolgreich geändert.",
    "reason_type": {
      "abort": "Abbruch",
      "death": "Tod",
      "fail": "Fehlgeschlagen",
      "success": "Erfolg"
    },
    "remark": "Bemerkung",
    "save_patient_schema": "Patientenschema gespeichert",
    "scheduled_start_date": "Regulärer Start",
    "start_date": "Startdatum",
    "status": "Status",
    "successfully_deleted_cycle": "Zyklus erfolgreich gelöscht.",
    "successfully_deleted_header": "Löschung",
    "successfully_ordered_multi": "Es wurden {count} Therapien erfolgreich bestellt.",
    "successfully_ordered_single": "Es wurde {count} Therapie erfolgreich bestellt.",
    "successfully_restored": "Therapien erfolgreich wiederhergestellt.",
    "successfully_restored_header": "Wiederherstellung",
    "successfully_saved": "Therapien erfolgreich erstellt.",
    "successfully_saved_break": "Verschiebung erfolgreich hinzugefügt.",
    "successfully_saved_break_header": "Verschiebung hinzugefügt",
    "successfully_saved_header": "Therapieerstellung",
    "successfully_saved_multi": "Der Status von {count} Therapien wurde erfolgreich gesetzt.",
    "successfully_saved_single": "Der Status von {count} Therapie wurde erfolgreich gesetzt.",
    "therapies": "Therapie(n)",
    "therapy": "Therapie",
    "therapy_successfully_deleted": "Die Therapien wurden erfolgreich gelöscht.",
    "timestamp": "Datum",
    "tooltip_add_details": {
      "h": "Neues Schema verlinken",
      "t": ""
    },
    "tooltip_collapse_all_therapies": {
      "h": "Alle Therapien zusammenklappen",
      "t": ""
    },
    "tooltip_collapse_therapy": {
      "h": "Therapien dieses Zykluses zusammenklappen",
      "t": ""
    },
    "tooltip_delete_last_cycle": {
      "h": "Letzten Zyklus löschen",
      "t": ""
    },
    "tooltip_delete_schema_break": {
      "h": "Verschiebung löschen",
      "t": ""
    },
    "tooltip_delete_therapy": {
      "h": "Therapien löschen",
      "t": "Hier können Sie Therapien löschen"
    },
    "tooltip_expand_all_therapies": {
      "h": "Alle Therapien aufklappen",
      "t": ""
    },
    "tooltip_expand_therapy": {
      "h": "Therapien dieses Zyklus aufklappen",
      "t": ""
    },
    "tooltip_negative_days_delay": {
      "h": "Therapie vor Startdatum des Zyklus vorgezogen",
      "t": ""
    },
    "tooltip_restore_therapy": {
      "h": "Therapien wiederherstellen",
      "t": ""
    },
    "tooltip_warning_holiday": {
      "h": "Therapie im Urlaub/gesetzlicher Feiertag",
      "t": ""
    },
    "tooltip_warning_weekend": {
      "h": "Therapie am Wochenende",
      "t": ""
    },
    "user": "Benutzer",
    "warning": "Warnung",
    "warning_carboplatin_schema_missing_creatinine_clearance": "Dies ist ein Carboplatin-Schema und es fehlen die Kreatinin-Clearance Werte.",
    "warning_not_owner_of_schema": "Dies ist ein Patientenschema eines anderen Standortes.",
    "warning_schema_created_by_pharmacy": "Das Patientenschema wurde von einer Apotheke angelegt und kann nicht weiter fortgeführt werden (Zyklen hinzufügen).",
    "warning_schema_is_closed": "Das Patientenschema wurde beendet.",
    "warning_text": "Die Daten wurden aufgrund eines Konfliktes aktualisiert.",
    "warning_vital_data_too_old": "Die Vitaldaten sind über 3 Monate alt. Sind diese noch aktuell?"
  },
  "component_patient_therapies": {
    "agent": "Wirkstoff",
    "application_date": "Applikationsdatum",
    "application_route": "Applikationsweg",
    "carrier_solution": "Trägerlösung",
    "dosis": "Dosis",
    "manufacturer": "Hersteller",
    "order_at_call": "Auf Abruf",
    "ordered_at": "Bestellt bei",
    "patient": "Patient",
    "schema_name": "Schema",
    "searching": "Applikationsdatum, Wirkstoff",
    "status": "Status",
    "successfully_order_at_call": "Auf Abruf erfolgreich geändert.",
    "type": "Typ"
  },
  "component_patient_vital_data": {
    "age": "Alter",
    "bmi": "BMI",
    "calculation": "Berechnung",
    "created": "Erstellt von",
    "creatinine": "Kreatinin",
    "creatinine_clearance": "Kreatinin-Clearance",
    "creatinine_clearance_methods": {
      "cockcroft": "Cockcroft-Gault",
      "jellife": "Jellife"
    },
    "creatinine_units": {
      "mg": "mg/dl",
      "mol": "µmol/l"
    },
    "date": "Datum",
    "ecog": "ECOG",
    "height": "Größe",
    "ideal_weight": "Idealgewicht",
    "karnofsky_ecog": "Karnofsky-/ECOG",
    "karnofsky_index": "Karnofsky Index (%)",
    "kof_methods": {
      "dubois": "Dubois",
      "manual": "Manuell",
      "manuell": "manuell",
      "mosteller": "Mosteller",
      "undefined": " --- "
    },
    "panels": {
      "creatine_clearance": "Kreatinin-Clearance",
      "current_vital_data": "Aktuelle Vitaldaten",
      "general_performance_state": "Allgemeiner Leistungszustand",
      "kof": "Körpermaße",
      "new_vital_data": "Neue Vitaldaten aufnehmen",
      "vital_data_progress": "Verlauf Vitaldaten"
    },
    "skin_surface": "Körperoberfläche",
    "skin_surface_method": "Berechnung",
    "vital_data_differ_strongly": "Die eingegebenen Vitaldaten weichen stark von denen das letzte Mal eingegebenen Vitaldaten ab. Sind diese korrekt?",
    "vital_data_no_creatinine_data": "Die Vitaldaten können nicht gespeichert werden, weil es noch geplante Therapien gibt, welche zur Berechnung der Dosierung einen Kreatinin Wert benötigen.",
    "vital_data_not_in_normal_range": "Die eingegebenen Vitaldaten liegen außerhalb des Normbereichs für einen erwachsenen Patienten. Sind diese korrekt?",
    "vital_data_successfully_saved": "Die Vitaldaten wurden erfolgreich gespeichert",
    "warning": "Achtung",
    "warning_creatinine_gt": "Der eingegebene Wert liegt oberhalb des typischen Wertebereichs von {expected} mg/dl, ist dies beabsichtigt?",
    "warning_creatinine_lt": "Der eingegebene Wert liegt unterhalb des typischen Wertebereichs von {expected} mg/dl, ist dies beabsichtigt?",
    "warning_creatinine_mol_gt": "Der eingegebene Wert liegt oberhalb des typischen Wertebereichs von {expected} µmol/l, ist dies beabsichtigt?",
    "warning_creatinine_mol_lt": "Der eingegebene Wert liegt unterhalb des typischen Wertebereichs von {expected} µmol/l, ist dies beabsichtigt?",
    "warning_text_changing_vital_data": "Bei Eingabe aktueller Vitaldaten werden alle bereits geplanten Zubereitungen neu berechnet.",
    "weight": "Gewicht",
    "years": "Jahre"
  },
  "component_pdf_container": {
    "title_dialog": "Dokument drucken"
  },
  "component_physician_my_holidays": {
    "buttons": {
      "add": "Hinzufügen"
    },
    "confirm_delete_holidays": {
      "header": "Urlaubseintrag löschen",
      "text": "Sind die sich sicher, dass sie diesen Urlaubseintrag löschen möchten?"
    },
    "date_pickers": {
      "date_from": "Datum von",
      "date_to": "Datum bis"
    },
    "panels": {
      "holidays": {
        "header": "Feiertage",
        "subheader": "Übersicht der standortspezifischen Feiertage"
      },
      "vacation_entries": {
        "header": "Urlaubseinträge",
        "subheader": "Übersicht und Verwaltung aller geplanten Abwesenheiten"
      }
    },
    "successfully_saved": "Urlaubseinträge wurden erfolgreich gespeichert",
    "successfully_saved_header": "Speicherung erfolgreich",
    "table": {
      "date": "Datum",
      "date_from": "Datum von",
      "date_to": "Datum bis",
      "days": "Anzahl Tage",
      "name": "Name"
    },
    "warning_header": "Warnung"
  },
  "component_physician_my_settings": {
    "advanced_settings": {
      "general": "Allgemeines",
      "on_call": "Therapien automatisch auf Abruf planen",
      "search_and_filter": "Suche & Filtereinstellungen beim Anlegen von Patientenschemen"
    },
    "agents": {
      "agent": "Wirkstoff",
      "agent_configuration": "Wirkstoff-Konfiguration",
      "agent_search": "Wirkstoffsuche",
      "biosimilar": "Biosimilar",
      "carrier_solution": "Trägerlösung",
      "comment": "Bemerkungen",
      "manufacturer": "Hersteller",
      "volume": "Volumen"
    },
    "buttons": {
      "add_agents": "Wirkstoff hinzufügen",
      "add_informations": "Allgemeine Information hinzufügen",
      "delete": "Löschen"
    },
    "calculation_bases": {
      "body_surface_calculation": "Körperoberfläche (KOF) Berechnung nach",
      "creatine_clearance": "Kreatin-Clearance Berechnung nach",
      "creatinine_value": "Verwendung folgender Einheit bei Kreatinineingabe."
    },
    "checkboxes": {
      "cockcroft-gault": "Cockcroft-Gault",
      "dubois": "Dubois",
      "jellife": "Jellife",
      "mosteller": "Mosteller",
      "no": "Nein",
      "unit_mg": "Einheit mg/dl",
      "unit_µmol": "Einheit µmol/l",
      "yes": "Ja"
    },
    "general_comments": {
      "comment": "Bemerkungen:"
    },
    "infusion_protocol_items_text": "Text",
    "infusion_protocol_items_title": "Titel",
    "my_settings_no_information": "Keine Informationen hinzugefügt",
    "panels": {
      "advanced_settings": {
        "header": "Planungseinstellungen",
        "new_patient_schema": "Neues Patientenschema anlegen:",
        "sub_header": "Alle Angaben zu Suchfiltern, Schemen und Berechnungsgrundlagen der Therapien."
      },
      "agents": {
        "header": "Wirkstoffe"
      },
      "calculation_bases": {
        "header": "Berechnungsgrundlagen"
      },
      "general_comments": {
        "header": "Allgemeine Bemerkungen"
      },
      "infusion_protocol": {
        "header": "Infusionsprotokoll",
        "sub_header": "Alle Angaben zur Konfiguration von Infusionsprotokollen"
      }
    },
    "successfully_saved": "Einstellungen erfolgreich gespeichert",
    "successfully_saved_header": "Speicherung erfolgreich",
    "switches": {
      "ideal_weight": "Bei Vitaldaten Idealgewicht zur Berechnung der KOF verwenden?",
      "ignore_icd_filter_per_default": "Patientendiagnosen (falls vorhanden) als Filter verwenden",
      "print_out_batch_numbers": "Chargennummern auf Infusionsprotokoll anzeigen",
      "print_out_general_information": "Allgemeine Informationen auf Infusionsprotokoll anzeigen",
      "print_out_schematic_information": "Schema-Informationen auf dem Infusionsprotokoll anzeigen",
      "use_praxis_schema_per_default": "Praxisschemen (falls vorhanden) zuerst durchsuchen"
    },
    "warning": "Wirkstoff schon vorhanden",
    "warning_header": "Warnung"
  },
  "component_physician_user_list": {
    "display_name": "Name",
    "email": "E-mail",
    "is_active": "Aktiv",
    "last_login": "Letzter Login",
    "tabs": {
      "new": "Neuer Benutzer"
    }
  },
  "component_popup_therapy_agents_basic_order": {
    "subtitle": {
      "edit": "Bearbeiten Sie einen oder mehrere Wirkstoffe für Ihre Anforderung.",
      "new": "Legen Sie einen oder mehrere Wirkstoffe für Ihre Anforderung an."
    }
  },
  "component_praxis_schema_details": {
    "agents": "Wirkstoff",
    "alternative_name": "Alternativname",
    "application_form": "Applikationsart",
    "application_route": "Applikationsweg",
    "buttons": {
      "btn_delete": {
        "tooltip": {
          "h": "Praxisschema löschen",
          "t": "Das ausgewählte Praxisschema löschen"
        }
      }
    },
    "carrier_solution": "Trägerlösung",
    "concomitant_agents": "Begleitmedikation",
    "day": "Tag",
    "dialog_title": "Infusionsprotokoll drucken",
    "dosage": "Dosierung",
    "error_no_application_route_abbreviation": "Wert nicht gefunden",
    "icd": "ICD-10",
    "icd_list": "ICD-10-Liste",
    "indication": "Indikation",
    "infusion_duration": "Infusionsdauer",
    "infusion_protocol": "Infusionsprotokollvorlage",
    "initial_dosage": "Initialdosierung",
    "is_active": "Aktiv",
    "length_of_cycle": "Zyklusdauer (in Tagen)",
    "name": "Name",
    "number_of_cycles": "Anzahl Zyklen",
    "oral_agents": "Orale Substanzen",
    "panels": {
      "agents": "Substanzen",
      "base_data": "Allgemein",
      "carrier_solutions": "Wässerung",
      "concomitant_agents": "Begleitmedikation",
      "cycles": "Zyklen",
      "oral_agents": "Orale Substanzen",
      "proprietary_agents": "Prä- und Postmedikation"
    },
    "praxis_schema": "Praxisschema",
    "praxis_schema_infusion_protocol_warning": "Es wurden neue Substanzen/Medikationen hinzugefügt. Bitte kontrollieren Sie die Infusionsprotokollvorlage.",
    "proprietary_agents": "Prä- und Postmedikation",
    "scheduling_duration": "Zeitlicher Ablauf",
    "selected": "(ausgewählt)",
    "successfully_saved": "Praxisschema wurde erfolgreich gespeichert",
    "successfully_saved_header": "Speicherung erfolgreich",
    "tabs": {
      "edit": "Praxisschema bearbeiten",
      "new": "Neues Praxisschema"
    },
    "taking_types": {
      "evening": "abends",
      "morning": "früh",
      "night": "nachts",
      "noon": "mittags"
    },
    "takings": "Einnahme",
    "top_category": "(Oberkategorie)",
    "total_volume": "Gesamtvolumen",
    "volume": "Volumen"
  },
  "component_praxis_schema_list": {
    "alternative_name": "Alternativname",
    "confirm_delete": "Möchten Sie das ausgewählte Praxisschema wirklich löschen?",
    "confirm_delete_header": "Praxisschema löschen",
    "context_menu": {
      "delete_praxis_schema": {
        "h": "Praxischema löschen",
        "t": "Das Praxischema löschen"
      }
    },
    "edit_infusion_protocol_tooltip_text": "Aktualisierung der Infusionsprotokollvorlage notwendig",
    "icd": "ICD-10",
    "infusion_protocol": "Infusionsprotokollvorlage",
    "infusion_protocol_hint": "Infusionsprotokollvorlage ist vorhanden",
    "is_inactive": "Inaktiv",
    "is_inactive_tooltip": "Das Praxisschema ist inaktiv",
    "length_of_cycle": "Zyklusdauer",
    "name": "Name",
    "number_of_cycles": "Anzahl Zyklen",
    "praxis_schema": "Praxisschema",
    "show_all_items": "Inaktive anzeigen",
    "successfully_deleted": "Praxisschema wurde erfolgreich gelöscht",
    "successfully_deleted_header": "Löschung erfolgreich",
    "tabs": {
      "edit": "Praxisschema bearbeiten",
      "new": "Neues Praxisschema"
    }
  },
  "component_register_new": {
    "cancel_process": "Vorgang abbrechen",
    "email": "E-Mail",
    "first_name": "Vorname",
    "headline": "Registrierung",
    "headline2": "Herzlich Willkommen",
    "last_name": "Nachname",
    "login_name": "Benutzername",
    "password": "Passwort",
    "password2": "Passwort wiederholen",
    "password_risk_email": "Das Passwort ist zu ähnlich zu Ihrer E-Mail-Adresse.",
    "password_risk_login_name": "Das Passwort ist zu ähnlich zum Benutzernamen.",
    "salutation": "Anrede",
    "sub_header": {
      "account_data": "Accountdaten",
      "account_data2": "Accountsicherheit",
      "personal_data": "Persönliche Daten"
    },
    "successfully_saved": "Vielen Dank für Ihre Registrierung. Ihr Account wurde freigeschaltet und Sie können sich nun anmelden.",
    "successfully_saved_header": "Registrierung erfolgreich",
    "text": "Herzlich Willkommen bei",
    "text2": "Sie wurden erfolgreich mit ihrer E-Mail, {value}, als Nutzer eingeladen. Bitte füllen Sie die verpflichtenden Felder und schließen Sie die Registrierung ab ",
    "text3": "registrieren.",
    "text4": "Sie wurden erfolgreich mit ihrer E-Mail ",
    "text5": ", als Nutzer eingeladen. Bitte füllen Sie alle verpflichtenden sowie optionalen Felder (wenn möglich) aus und schließen die Registrierung ab.",
    "title": "Titel"
  },
  "component_select_location": {
    "back_to_login": "Zurück zum Login",
    "location_choice": "Standort auswählen"
  },
  "component_tab_navigation": {
    "confirm_delete_content": "Es wurden Änderungen vorgenommen, diese gehen beim Schließen verloren. Soll das Tab dennoch geschlossen werden?",
    "confirm_delete_header": "Tab schließen"
  },
  "component_tab_patient_basic_orders": {
    "application_date": "Applikationsdatum",
    "buttons": {
      "use_template": "Vorlage verwenden"
    },
    "confirm_header": "Vorlage verwenden",
    "confirm_use_template": "Möchten sie die Vorlage wirklich verwenden?",
    "cycle": "Zyklus",
    "partner": "Bestellt bei",
    "schema_name": "Schemaname"
  },
  "component_tab_patient_common_basic_order": {
    "alerts": {
      "creatinine_clearance_alert": "Dies ist ein Carboplatin-Schema und es fehlen die Kreatinin-Clearance Werte.",
      "creatinine_clearance_method_alert": "Die Kreatinine-Clearance kann nur gesetzt werden, wenn Geschlecht und Geburtsdatum eingegeben wurden sind.",
      "duplicate_patient": "Patienten mit diesen Stammdaten und/oder dieser Versicherungsnummer existeren bereits:",
      "required_alert": "Zum erstmaligen Speichern werden Stammdaten, Krankenversicherungsdaten und Vitaldaten benötigt.",
      "required_vital_data_alert": "Zum Speichern werden noch die Vitaldaten benötigt."
    },
    "basic_order_order": "Bestellung",
    "basic_order_order_successfully_approved": "Anforderung erfolgreich freigegeben.",
    "basic_order_order_successfully_changed": "Anforderung erfolgreich bestellt.",
    "buttons": {
      "add_cycle": "Hinzufügen",
      "add_vital_data": "Vitaldaten hinzufügen",
      "approve": {
        "h": "Freigeben",
        "t": "Anforderung freigeben"
      },
      "edit_vital_data": "Vitaldaten bearbeiten",
      "ignore": "Ignorieren",
      "order": {
        "h": "Bestellen",
        "t": "Anforderung bestellen"
      },
      "show_vital_data_history": "Verlauf der Vitaldaten"
    },
    "create_default_order": "Anforderung aus dieser Vorlage erstellen",
    "create_new_order": "Leere Anforderung erstellen",
    "date_of_birth": "Geburtsdatum",
    "date_of_death": "Sterbedatum",
    "delivery_date_info_text": "Es werden Therapien für mehrere Tage geplant, daher kann kein generelles Lieferdatum angegeben werden.",
    "delivery_date_requested": "Möchten Sie ein Lieferdatum auswählen?",
    "delivery_notes": "Lieferhinweise",
    "dosage": "Dosis",
    "end_date_insurance_exemption": "befreit bis",
    "first_name": "Vorname",
    "gender": "Geschlecht",
    "info_text": "Diese Anforderung wurde bestellt. Sie können jetzt eine neue Anforderung erstellen oder diese Vorlage wieder verwenden.",
    "insurance_company": "Krankenkasse",
    "insurance_data_or": "oder",
    "insurance_number": "Versichertennummer",
    "insurance_state": "Versicherungsstatus",
    "is_exempt": "Zuzahlungsbefreit",
    "last_name": "Nachname",
    "message_password_required": "Das Passwort wird benötigt.",
    "message_wrong_password": "Das eingegebene Passwort ist falsch.",
    "name_prefix": "Namensvorsatz",
    "panels": {
      "common_data": {
        "header": "Stammdaten",
        "sub_header": "Alle personenbezogenen Daten"
      },
      "insurance_data": {
        "header": "Krankenversicherungsdaten",
        "sub_header": "Alle Angaben zur Krankenversicherung des Patienten"
      },
      "request": {
        "header": "Anforderung",
        "sub_header": "Alle Angaben zur Anforderung"
      },
      "vital_data": {
        "header": "Vitaldaten",
        "sub_header": "Alle Angaben zu den Vitaldaten des Patienten"
      }
    },
    "patient_number": "AIS-ID",
    "patient_successfully_changed": "Der Patient wurde erfolgreich geändert",
    "patient_successfully_saved": "Der Patient wurde erfolgreich gespeichert",
    "percentage_of_dosage": "% Wert von Originaldosis",
    "replacement_code": "Ersatzcode",
    "save_patient": "Patient gespeichert",
    "start_date_insurance_exemption": "befreit ab",
    "sub_header": {
      "cycles": "Zyklen",
      "delivery": "Lieferung",
      "therapy_agents": "Substanzen"
    },
    "title": "Titel",
    "tool_tip_insurance_state_others": "Ist der Patient weder gesetzlich noch privat versichert oder sind die Versichertenangaben unvollständig, ist einer der entsprechenden Ersatzcodes mit ergänzenden Informationen anzugeben.",
    "tool_tip_insurance_state_private": "Sollte das Institutionskennzeichen der privaten Kasse nicht bekannt sein, ist behelfsmäßig der Versichertenstatus \"sonstige\" unter Einsatz des entsprechenden Ersatzcodes zu verwenden."
  },
  "component_tab_therapies": {
    "agent": "Wirkstoff",
    "application_date": "Applikationsdatum",
    "carrier_solution": "Trägerlösung",
    "confirm_delete_header": "Therapie löschen",
    "confirm_set_status_to_applied": "Möchten Sie die {count} Therapien wirklich auf verabreicht setzen?",
    "confirm_set_status_to_canceled": "Möchten Sie die {count} Therapien wirklich absagen?",
    "confirmation": "Bestätigung",
    "context_menu": {
      "add_vital_data": {
        "h": "Vitaldaten hinzufügen",
        "t": "Die Vitaldaten hinzufügen"
      },
      "apply_therapies": {
        "h": "Therapie verabreichen",
        "t": "Therapie auf verabreicht setzen"
      },
      "cancel_therapies": {
        "h": "Therapie absagen",
        "t": "Therapie auf abgesagt setzen"
      },
      "copy_label": {
        "h": "Verordnung kopieren",
        "t": "Verordnung in die Zwischenablage kopieren"
      },
      "delete_therapy": {
        "h": "Therapie Löschen",
        "t": "Die ausgewählte Therapie löschen"
      },
      "open_patient": {
        "h": "Patient öffnen",
        "t": "Den Patienten öffnen"
      },
      "open_patient_schema": {
        "h": "Patientenschema öffnen",
        "t": "Das Patientenschema öffnen"
      },
      "show_status": {
        "h": "Status anzeigen",
        "t": "Status anzeigen"
      }
    },
    "delete_therapy": "Therapie gelöscht",
    "delete_therapy_confirmation_multi": "Sollen die {count} Therapien wirklich gelöscht werden?",
    "delete_therapy_confirmation_single": "Soll die Therapie wirklich gelöscht werden?",
    "dosage": "Dosis",
    "manufacturer": "Hersteller",
    "master_detail": {
      "agents": "Wirkstoffe",
      "application_date": "Applikationsdatum",
      "carrier_solution": "Trägerlösung",
      "context_menu": {
        "cancel_order": {
          "h": "Therapie stornieren",
          "t": "Diese Therapie stornieren."
        },
        "copy_order": {
          "h": "Verordnung kopieren",
          "t": "Diese Verordnung in die Zwischenablage kopieren."
        },
        "copy_therapy_data": {
          "h": "Therapiedaten kopieren",
          "t": "Diese Therapiedaten in die Zwischenablage kopieren."
        }
      },
      "day": "Tag",
      "delivery_date": "Lieferdatum",
      "dosages": "Dosis",
      "manufacturer": "Hersteller",
      "schema_dosage": "Dosierung",
      "status": "Bestellstatus"
    },
    "message_failed_applied_therapies_multi": "Diese {count} Therapien können nicht auf verabreicht gesetzt werden (Applikationsdatum in Zukunft).",
    "message_failed_applied_therapies_single": "Diese {count} Therapie kann nicht auf verabreicht gesetzt werden (Applikationsdatum in Zukunft).",
    "message_failed_order_therapies": "Die Therapien konnten nicht bestellt werden.",
    "message_failed_order_therapies_multi": "{count} Therapien konnten nicht freigegeben werden.",
    "message_failed_order_therapies_single": "{count} Therapie konnte nicht freigegeben werden.",
    "message_failed_set_status_therapies_multi": "Der Status von {count} Therapien konnte nicht gesetzt werden.",
    "message_failed_set_status_therapies_single": "Der Status von {count} Therapie konnte nicht gesetzt werden.",
    "message_password_required": "Das Passwort wird benötigt.",
    "message_wrong_password": "Das eingegebene Passwort ist falsch.",
    "message_wrong_therapy_status_for_cancel": "Einige ausgewählte Therapien haben einen falschen Status für die Aktion: Absage.",
    "message_wrong_therapy_status_for_order": "Einige ausgewählte Therapien haben einen falschen Status für die Aktion: Bestellung.",
    "order_at_call": "Auf Abruf",
    "order_therapy": "Bestellung",
    "ordered_at": "Bestellt bei",
    "patient": "Patient",
    "process_canceled": "Vorgang abgebrochen",
    "save_therapy_status": "Status gesetzt",
    "schema_name": "Schema",
    "searching": "Applikationsdatum, Wirkstoff, Patient",
    "status": "Status",
    "successfully_order_at_call": "Auf Abruf erfolgreich geändert.",
    "successfully_ordered_multi": "Es wurden {count} Therapien erfolgreich bestellt.",
    "successfully_ordered_single": "Es wurde {count} Therapie erfolgreich bestellt.",
    "successfully_saved_multi": "Der Status von {count} Therapien wurde erfolgreich gesetzt.",
    "successfully_saved_single": "Der Status von {count} Therapie wurde erfolgreich gesetzt.",
    "tab_therapy_title": "Therapie ({date})",
    "therapy_successfully_deleted": "Die Therapie wurde erfolgreich gelöscht.",
    "type": "Typ"
  },
  "component_therapy_details": {
    "add_negative_days": "Verschieben",
    "agent": "Wirkstoff",
    "agents": "Wirkstoffe",
    "alert_break_found": "Mit diesem Applikationsdatum gibt es einen Konflikt mit Urlaubseinträgen oder gesetzlichen Feiertagen.",
    "alert_negative_delay": "Das Datum liegt vor dem Zyklusbeginn und kann bis zum Datum der letzten Therapie des vorherigen Zykluses verschoben werden",
    "alert_therapy_in_past": "Dieses Formular kann nicht weiter bearbeitet werden, weil das Applikationsdatum in der Vergangenheit liegt.",
    "application_container": "Appl.-behältnis",
    "application_date": "Applikationsdatum",
    "application_forms": "Applikationsart",
    "application_routes": "Applikationsweg",
    "application_supply": "Appl.-zubehör",
    "buttons": {
      "copy_label": "Verordnung kopieren",
      "status_history": "Statusverlauf anzeigen"
    },
    "carrier_solution": "Trägerlösung",
    "carrier_solutions": "Trägerlösungen",
    "charges": "Chargen",
    "current_status": "Aktueller Status:",
    "cycle": "Zyklus",
    "day": "Tag",
    "delivery_date": "Lieferdatum",
    "delivery_instructions": "Lieferhinweise",
    "dosage": "Dosierung",
    "dosage_changed": "Es wurde eine Dosisänderung vorgenommen. Soll diese Dosis für alle nachfolgenden Therapien ebenfalls übernommen werden?",
    "dose": "Dosis",
    "expiry_date": "Haltbarkeitsdatum",
    "infusion_duration_hours": "Infusionsdauer Stunden",
    "infusion_duration_minutes": "Infusionsdauer Minuten",
    "label": "Verordnung",
    "light_protection": "Lichtschutz",
    "manufacturer": "Hersteller",
    "negative_days_delay": "{days} Tage Verschiebung",
    "order_at_call": "Therapie auf Abruf setzen?",
    "panels": {
      "agent": "Wirkstoff",
      "general": "Schemainformationen",
      "manufacturing": "Herstellungsdetails",
      "miscellaneous": "Sonstiges",
      "status": "Therapiedetails"
    },
    "patient": "Patient",
    "schema": "Schemaname (Verlinkung)",
    "snackbars": {
      "successfully_saved": "Therapie erfolgreich gespeichert",
      "successfully_saved_header": "Speicherung erfolgreich",
      "successfully_saved_status": "Status erfolgreich geändert",
      "successfully_saved_status_header": "Änderung erfolgreich"
    },
    "start_date": "Startdatum",
    "storage_temperature_of_the_preparation": "Lagerungstemperatur der Zubereitung",
    "tab_subtitle_patient_schema": "Patientenschema: ",
    "time_start": "Uhrzeit",
    "title": "Therapie ({date})",
    "total_volume": "Gesamtvolumen",
    "type": "Typ",
    "value_from_original_dose": "% Wert von Originaldosis",
    "warning_below_dosage": "Unterdosierung (< 95%)",
    "warning_delivery_date_in_past": "Das Lieferdatum liegt in der Vergangenheit",
    "warning_over_dosage": "Überdosierung (> 105%)"
  },
  "component_therapy_list": {
    "finished": "Abgeschlossen",
    "ordered": "Bestellt",
    "planned": "Geplant"
  },
  "component_user_details": {
    "active": "Aktiv",
    "attention": "ACHTUNG",
    "confirm_delete": "Möchten Sie den Nutzer wirklich deaktivieren?",
    "confirm_delete_header": "Deaktivierung",
    "email": "E-Mail",
    "first_name": "Vorname",
    "frontend_version": "Clientversion des Benutzers",
    "inactive": "Inaktiv",
    "last_login": "Letzter Login",
    "last_name": "Nachname",
    "location": "Standort",
    "location_not_selected": "Standort nicht ausgewählt",
    "location_selected": "Standort ausgewählt",
    "login_name": "Benutzername",
    "panels": {
      "user_data": {
        "header": "Benutzerdaten",
        "subheader": "Allgemeine Daten eines Nutzers"
      },
      "user_roles": {
        "header": "Benutzerrollen",
        "subheader": "Weisen Sie dem aktuellen Nutzer seine Rolle(n) zu"
      }
    },
    "role_not_selected": "Rolle nicht ausgewählt",
    "role_selected": "Rolle ausgewählt",
    "salutation": "Anrede",
    "selection_locations_and_roles": "Standort- / Rollenauswahl",
    "selection_roles": "Rollenauswahl",
    "successfully_saved": "Benutzerdaten erfolgreich gespeichert",
    "successfully_saved_header": "Speicherung erfolgreich",
    "tab_sub_title": "Benutzer",
    "text_disabled_by_root": "Dieser Nutzer wurde vom Systemadministrator anwendungsweit inaktiv gesetzt und kann sich nicht mehr einloggen. Bei Fragen wenden Sie sich bitte an den Systemadministrator.",
    "text_disabled_by_root_as_root": "Dieser Nutzer wurde von Ihnen anwendungsweit inaktiv gesetzt und kann sich somit nicht mehr einloggen.",
    "text_inactivity": "Bei Inaktivität kann sich der Nutzer gar nicht mehr am System anmelden. Um einen Nutzer für einen bestimmten Standort zu deaktivieren benutzen sie bitte die Rolle 'Deaktiviert' für den jeweiligen Standort.",
    "text_own_user": "Bei dem ausgewählten Nutzer handelt es sich um Sie selbst. Um Komplikationen zu vermeiden, können Sie sich nicht selbst deaktivieren bzw. auch die Rolle 'Benutzeradmin' nicht deaktivieren.",
    "text_own_user_root": "Bei dem ausgewählten Nutzer handelt es sich um sie selbst, den Root-Nutzer. Um Komplikationen zu vermeiden, können Sie sich nicht selbst inaktiv setzen.",
    "title": "Titel"
  },
  "component_user_list": {
    "active": "Aktiv",
    "active_dialog": {
      "header": "Rolle 'deaktiviert' zuweisen",
      "text": "Möchten Sie dem Nutzer {user} wirklich die Rolle 'deaktiviert' zuweisen?"
    },
    "context_delete_user": {
      "description": "Löscht den ausgewählten Nutzer",
      "title": "Nutzer löschen"
    },
    "context_set_user_role_inactive": {
      "description": "Weist dem ausgewählten Nutzer die Rolle 'deaktiviert' zu oder entzieht diese",
      "title": "Rolle 'deaktiviert' zuweisen/entziehen"
    },
    "created": "Erstellt am",
    "delete_dialog": {
      "header": "Nutzer löschen",
      "text": "Möchten Sie den Nutzer {user} wirklich löschen?\n\nBeachten Sie: Dann wird der Nutzer aus der entsprechenden Anwendung entfernt. Handelt es sich um die einzige oder einzig verbliebene Anwendung, wird der Nutzer aus dem kompletten System entfernt."
    },
    "delete_dialog_attention": {
      "header": "Achtung!",
      "text": "Sie können sich aus Sicherheitsgründen nicht selbst löschen."
    },
    "delete_user": {
      "header": "Nutzer gelöscht",
      "text": "Nutzer wurde erfolgreich gelöscht."
    },
    "email": "E-Mail",
    "first_name": "Vorname",
    "frontend_version": "Frontend Version",
    "inactive": "Inaktiv",
    "inactive_dialog": {
      "header": "Rolle 'deaktiviert' entziehen",
      "text": "Möchten Sie dem Nutzer {user} wirklich die Rolle 'deaktiviert' entziehen?"
    },
    "inactive_dialog_attention": {
      "header": "Achtung!",
      "text": "Sie können sich aus Sicherheitsgründen nicht selbst inaktiv setzen."
    },
    "inactive_tooltip_text": "Nutzer ist inaktiv",
    "is_active": "Aktiv",
    "last_login": "Letzter Login",
    "last_name": "Nachname",
    "login_name": "Benutzername",
    "salutation": "Anrede",
    "successfully_deleted": "Nutzer wurde erfolgreich gelöscht.",
    "successfully_deleted_header": "Nutzer gelöscht",
    "title": "Titel",
    "userType": "Usertyp"
  },
  "ERROR": "Fehler",
  "ERROR_ACTIVATING_2FA": "Der 2FA konnte nicht aktiviert werden.",
  "ERROR_BAD_REQUEST": "Fehlerhafte Anfrage.",
  "ERROR_CHECKING_TRUST_TOKEN": "Der Anmeldetoken konnte nichtüberprüft werden.",
  "ERROR_CREATING_PDF": "Fehler beim Erstellen eines PDF.",
  "ERROR_DEACTIVATING_2FA": "Der 2FA konnte nicht deaktiviert werden.",
  "ERROR_DELETE_PATIENT_HAS_THERAPIES": "Patient kann nicht gelöscht werden, weil Therapien vorhanden sind.",
  "ERROR_DELETING_DATA": "Die Daten konnten nicht gelöscht werden.",
  "ERROR_DELETING_FILE_IN_BUCKET": "Die Datei konnte nicht gelöscht werden.",
  "ERROR_DELETING_TRUST_TOKEN": "Der Anmeldetoken konnte nicht gelöscht werden.",
  "ERROR_DUPLICATE_VALUE": "Der Wert ist bereits vorhanden",
  "ERROR_FILE_IS_EMPTY": "Die Datei ist leer.",
  "ERROR_GENERATING_2FA": "Der 2FA konnte nicht erstellt werden.",
  "ERROR_GENERATION_BACKUP_CODES": "Die 2FA Backup-Codes konnten nicht erstellt werden.",
  "ERROR_GETTING_2FA_STATUS": "Der 2FA Status konnte nicht abgerufen werden.",
  "ERROR_INCORRECT_PASSWORD": "Das eingegebene Passwort ist falsch.",
  "ERROR_INTERNAL_SERVER_ERROR": "Es ist ein Fehler aufgetreten",
  "ERROR_INVALID_ROUTE": "Invalide Route beim Restserver.",
  "ERROR_INVALID_VALUE": "Fehlerhafte Daten.",
  "ERROR_LOADING_DATA": "Die Daten konnten nicht geladen werden.",
  "ERROR_LOADING_FILE_FROM_BUCKET": "Die Datei konnte nicht geladen werden.",
  "ERROR_LOADING_FILE_LIST_FROM_BUCKET": "Die Liste der Dateien konnte nicht geladen werden.",
  "ERROR_LOADING_PERMISSIONS": "Fehler beim Laden von Zugriffsrechten.",
  "ERROR_LOCATION_NOT_FOUND": "Standort nicht gefunden.",
  "ERROR_LOCATION_TYPE": "Falscher Standorttyp.",
  "ERROR_LOGIN": "Sie konnten nicht angemeldet werden.",
  "ERROR_LOGOUT_USER": "Sie konntne nicht ausgeloggt werden.",
  "ERROR_NO_DATA": "Keine Daten vorhandem.",
  "ERROR_NO_SERVER": "Kein Restserver vorhanden.",
  "ERROR_NOT_CHANGED_DATA": "Daten wurden nicht geändert.",
  "ERROR_PARSING_FILE": "Fehler beim Analysieren der Datei.",
  "ERROR_PASSWORD_REQUIRED": "Das Passwort wird benötigt.",
  "ERROR_PIN_NOT_FOUND": "PIN konnte nicht gefunden werden",
  "ERROR_PROCESS_UNMARSHALLING": "Fehlerhafte Daten.",
  "ERROR_PROCESS_VALIDATION": "Fehlerhafte Daten.",
  "ERROR_READING_FILE": "Fehler beim Lesen der Datei.",
  "ERROR_REFRESHING_TOKEN": "Beim Erneuern des Anmeldetokens ist ein Problem aufgetreten.",
  "ERROR_SAVING_DATA": "Fehler beim Speichern der Daten.",
  "ERROR_SAVING_XAPI_DATA": "Fehler beim Speichern von Benutzer/Accountdaten",
  "ERROR_SEND_MAIL": "Fehler beim Versenden einer E-Mail.",
  "ERROR_STATUS_NOT_FOUND": "Der Status wurde nicht gefunden.",
  "ERROR_STATUS_NOT_IN_NEXT_LIST": "Der Status befindet sich nicht in der Liste der nächsten möglichen Stati.",
  "ERROR_STORING_FILE_IN_BUCKET": "Die Datei konnte nicht gespeichert werden.",
  "ERROR_UNSUPPORTED_FILE_TYPE": "Dieser Dateityp wird nicht unterstüzt.",
  "ERROR_USER_ACCOUNT_UPDATE_EMAIL_BY_TOKEN": "Die E-Mail konnte nicht geändert werden, evtl. ist das Passwort falsch gewesen.",
  "ERROR_USER_ACCOUNT_UPDATE_LOGIN_BY_TOKEN": "Der Benutzername konnte nicht geändert werden, evtl. ist das Passwort falsch gewesen.",
  "ERROR_USER_HAS_NO_ACCESS_TO_STATUS": "Sie haben keinen Zugriff auf diesen Status",
  "ERROR_USER_NOT_FOUND": "Mitarbeiter nicht gefunden.",
  "ERROR_WORKFLOW_LIST_NOT_FOUND": "Die Liste der Workflows wurde nicht gefunden.",
  "field_server_validation": {
    "additional_property_not_allowed": "Zusätzliche Daten sind beim Speichern nicht erlaubt.",
    "array_max_items": "Es müssen maximal alle Elemente ausgewählt werden.",
    "array_min_items": "Es muss mindestens ein Element ausgewählt werden.",
    "enum": "Der eingegebene/ausgewählte Wert befindet sich nicht in der Liste: {expected}.",
    "error_duplicate_partner": "Der Partner '{expected}' ist bereits verlinkt.",
    "error_duplicate_value": "Der Wert ist bereits vorhanden.",
    "error_invalid_value": "Der Wert ist nicht zulässig.",
    "error_pin_not_found": "Es konnte kein Partner mit diesem PIN gefunden werden.",
    "error_wrong_passcode": "Der eingegebene Code ist falsch.",
    "error_wrong_password": "Das eingegebene Passwort ist falsch.",
    "format": "Der Wert hat ein ungültiges Format: {expected}.",
    "invalid_type": "Der Wert hat einen falschen Datentyp.",
    "login_exists_already": "Der angegebene Benutzername existiert bereits.",
    "missing_dependency": "Es fehlt eine Abhängigkeit.",
    "number_gt": "Der Wert ist zu klein (min {expected}).",
    "number_lt": "Der Wert ist zu groß (max {expected}).",
    "pattern": "Das Pattern ist falsch.",
    "required": "Dies ist ein Pflichtfeld.",
    "string_gte": "Der Wert ist zu klein (min {expected} Zeichen).",
    "string_lte": "Der Wert ist zu groß (max {expected} Zeichen).",
    "unique": "Der Wert ist in der Datenbank nicht eindeutig.",
    "value_max": "Der Wert muss kleiner/gleich {expected} sein.",
    "value_min": "Der Wert muss größer/gleich {expected} sein."
  },
  "field_validation": {
    "additional_property_not_allowed": "Zusätzliche Daten sind beim Speichern nicht erlaubt.",
    "agent_not_multiple": "Der Wirkstoff wurde bereits ausgewählt.",
    "array_min_items": "Es muss mindestens ein Element ausgewählt werden.",
    "array_range_reversed": "Ein Wertebereich ist in umgekehrter Reihenfolge.",
    "at_least_one_true": "Es muss mindestens ein Tag ausgewählt sein.",
    "check_carrier_solution": "Der Wirkstoff hat eine inkompatible Trägerlösung.",
    "check_date_range_intersections": "Die Verschiebung liegt in einem anderen Verschiebungszeitraum.",
    "check_equality_dosage_initial_dosage": "Der Wert von Dosierung und Initialdosierung darf nicht gleich sein.",
    "check_inactive_agent": "Dieser Wirkstoff ist inaktiv.",
    "check_max_date_span_in_days": "Die Verschiebung ist zu lang",
    "check_valid_date": "Das Datumsformat ist ungültig.",
    "check_valid_time": "Das Zeitformat ist ungültig.",
    "check_volume": "Dieser Wert liegt außerhalb des zulässigen Bereichs von {min} ml und {max} ml für diesen Wirkstoff.",
    "check_volume_min": "Der Wert darf nicht unterhalb des minimalen Gesamtvolumens von {min} ml liegen.",
    "cycle_length_exceeded": "Die Zykluslänge von {lengthOfCycle} wurde überschritten.",
    "date_greater_than_cycle_start": "Das Applikationsdatum darf nicht vor dem Startdatum des Zykluses liegen ({date}).",
    "date_greater_than_earliest_date": "Das Applikationsdatum muss größer sein als das höchste Applikationsdatum im letzten Zyklus (mind. {date}).",
    "date_in_break": "Das Applikationsdatum befindet sich innerhalb einer Verschiebung ({date} - {days} Tage).",
    "date_in_break_single": "Das Applikationsdatum befindet sich innerhalb einer Verschiebung ({date} - {days} Tag).",
    "date_lesser_than_latest_date": "Das Applikationsdatum muss kleiner sein als das früheste Applikationsdatum des folgenden Zyklusses (max. {date}).",
    "date_lower_than_cycle_end": "Das Applikationsdatum muss kleiner/gleich sein als das Endedatum des Zykluses ({date}).",
    "date_lower_than_cycle_start": "Das Applikationsdatum muss kleiner sein als das Startdatum des Zykluses ({date}).",
    "date_must_be_greater_or_equal_than": "Das Datum muss größer gleich sein als der {date}.",
    "date_must_be_greater_than": "Das Datum muss größer sein als der {date}.",
    "date_must_be_lesser_than": "Das Datum darf nicht größer sein als der {date}.",
    "date_must_be_lesser_than_start": "Das Datum darf nicht größer sein als das Startdatum.",
    "date_not_before_last_entry": "Das Datum darf nicht vor dem letzten Eintrag am {date} liegen.",
    "date_not_in_future": "Das Datum darf nicht in der Zukunft liegen.",
    "date_not_in_past": "Das Datum darf nicht in der Vergangenheit liegen.",
    "date_not_more_than_one_year_in_past": "Das Datum darf nicht mehr als 1 Jahr in der Vergangenheit liegen.",
    "date_overlap": "Der Urlaubseintrag überschneidet sich mit einem anderen Urlaubseintrag.",
    "duplicate_ranges_invalid": "Doppelte Werte sind ungültig.",
    "duplicates_invalid": "Dopplungen sind ungültig.",
    "email_exists_already": "Die angegebene E-Mail-Adresse existiert bereits.",
    "enum": "Der eingegebene/ausgewählte Wert befindet sich nicht in der Liste: {allowed}.",
    "error_duplicate_value": "Der Wert ist bereits vorhanden.",
    "error_invalid_value": "Der Wert ist nicht zulässig.",
    "error_wrong_passcode": "Der eingegebene Code ist falsch.",
    "exact_length_characters": "Der Wert muss {count} Zeichen haben.",
    "format": "Der Wert hat ein ungültiges Format: {format}.",
    "hourAndMinutesZero": "Beide Werte dürfen nicht 0 sein.",
    "hours_existing": "Der Wert muss zwischen 0 und 59 liegen.",
    "hours_not_existing": "Der Wert muss zwischen 0 und 120 liegen.",
    "icd_code_exists_already": "Den ICD-10-Code gibt es schon.",
    "icd_code_higher_to": "Der ICD-10-Code muß größer dem Wert von {value} sein.",
    "icd_code_same_letter": "Der ICD-10-Code muss dem Kode-Bereich von {value} entsprechen.",
    "information_title_to_short": "Der Wert muss mindestens 2 Zeichen lang sein.",
    "insurance_company_ik_is_not_valid_legal": "Das Institutionskennzeichen entspricht nicht dem Aufbau einer gesetzlichen Krankenversicherung.",
    "insurance_company_ik_is_not_valid_others": "Das Institutionskennzeichen muss neunstellig sein und darf nur aus Zahlen bestehen.",
    "insurance_company_ik_is_not_valid_private": "Das Institutionskennzeichen entspricht nicht dem Aufbau einer privaten Krankenversicherung.",
    "insurance_company_ik_is_not_valid_unknown": "Die Krankenkassendaten sind ungültig.",
    "insurance_company_must_be_selected": "Dies ist ein Pflichtfeld. Es muss eine Krankenversicherung ausgewählt sein.",
    "insurance_number_is_invalid": "Die Versichertennummer ist ungültig.",
    "insurance_replacement_code_must_be_selected": "Dies ist ein Pflichtfeld. Entweder der Ersatzcode oder eine Krankenversicherung muss ausgewählt sein.",
    "invalid_email": "Ungültige E-Mail-Adresse",
    "invalid_input": "Ungültige Eingabe",
    "invalid_input_day": "Ungültige Eingabe (gültiges Format z.B.: '1,2,5-7,11').",
    "invalid_input_negative_day": "Der Wert im Negativbereich darf nur zwischen -1 und -999 liegen.",
    "invalid_type": "Der Wert hat einen falschen Datentyp.",
    "is_same_user": "Dies ist ihr aktueller Benutzername, bitte wählen Sie einen anderen oder brechen den Vorgang ab.",
    "length_of_cycle_too_small": "Die Länge des Zyklus ist zu gering (mind. {value}).",
    "login_exists_already": "Der angegebene Benutzername existiert bereits.",
    "login_special_characters_not_allowed": "Der Benutzername darf kein {'@'}-Zeichen enthalten.",
    "max_characters": "Der Wert darf maximal {count} Zeichen haben.",
    "max_greater_or_equal_min": "Der Maximalwert muss größer/gleich dem Minimalwert sein.",
    "min_characters": "Der Wert muss mindestens {count} Zeichen haben.",
    "no_range_reversed": "Von-/Bis-Werte sind ungültig.",
    "no_spaces_at_begin_and_end": "Der Wert darf nicht mit Leerzeichen beginnen oder enden.",
    "not_complex_enough": "Das Passwort muss zwingend Klein- und Großbuchstaben sowie Zahlen enthalten.",
    "number_gte": "Der Wert ist zu klein.",
    "number_lte": "Der Wert ist zu groß.",
    "number_of_cycles_too_small": "Die Anzahl der Zyklen ist zu gering.",
    "password_equal": "Passwörter müssen gleich sein.",
    "password_risk_email": "Das Passwort ist zu ähnlich zu Ihrer E-Mail-Adresse.",
    "required": "Dies ist ein Pflichtfeld.",
    "required_time": "Dies ist ein Pflichtfeld (Stunde, Minute oder beides).",
    "schema_total_duration_to_big": "Die Gesamtdauer des Schemas ist zu groß (max 9999 Tage).",
    "string_lte": "Der Wert ist zu groß (max {max} Zeichen).",
    "time_conflict": "Es besteht ein Zeitkonflikt am %s.",
    "validate_times": "Die Endzeit muss größer sein als die Startzeit.",
    "value_max": "Der Wert muss kleiner/gleich {value} sein.",
    "value_min": "Der Wert muss größer/gleich {value} sein.",
    "value_not_atc_code": "Der Wert muss dem Format eines ATC-Codes entsprechen.",
    "value_not_in_range": "Der Wert muss zwischen {min} und {max} liegen.",
    "value_to_long": "Es sind maximal {max} Zeichen erlaubt.",
    "zero_not_allowed": "Der Wert darf nicht 0 sein.",
    "zipCode": "Der Wert muss ein deutsches Postleitzahlenformat haben."
  },
  "filter": {
    "switchInactive": {
      "tooltip": {
        "h": "Inaktive anzeigen",
        "t": "Hier können Sie Inaktive ein- und ausblenden."
      }
    }
  },
  "Internal Server Error": "Es ist ein Fehler aufgetreten.",
  "invalid or expired jwt": "Fehler: Unauthorizierter Zugriff",
  "locationTypes": {
    "basic_order": "Basis Bestellung",
    "pharmacy": "Apotheke",
    "physician": "Arzt"
  },
  "locationTypesNew": {
    "basic_order": "Neue Basis Bestellung",
    "pharmacy": "Neue Apotheke",
    "physician": "Neuer Arzt"
  },
  "locationTypesShort": {
    "basic_order": "BB",
    "pharmacy": "Ap",
    "physician": "Ar"
  },
  "lx_tree_view": {
    "header": "Standort- / Rollenauswahl",
    "location": "Standort",
    "role_not_selected": "Rolle nicht ausgewählt",
    "role_selected": "Rolle ausgewählt"
  },
  "main_app": {
    "app_settings": "App-Einstellungen",
    "app_settings_info": "Individualisieren Sie die Anwendung",
    "dashboard": "Dashboard",
    "header_navigation": "Navigation",
    "info_navigation": "Wichtige Informationen auf einen Blick",
    "settings": {
      "change_brightness": "Helligkeitsmodus ändern",
      "change_color_schema": "Farbschema ändern",
      "change_language": "Sprachauswahl",
      "change_layout_appearance": "Layout-Aufbau",
      "change_layout_appearance_tab": "Tab-Layout",
      "change_layout_appearance_vertical": "Vertikales Layout",
      "change_layout_size": "Layout-Größe",
      "change_less_color": "Farbverteilung ändern",
      "header": "Einstellungen",
      "layout_size_default": "Standard",
      "set_tab_value": "Hier können Sie das Tab-Layout setzten.",
      "set_value": "Aktivität setzen",
      "set_vertical_value": "Hier können Sie das vertikale Layout setzten.",
      "tab_layout": "Tab-Layout",
      "vertical_layout": "Vertikales Layout"
    }
  },
  "messages": {
    "invalid_params": "Die Daten konnten aufgrund fehlerhafter Parameter nicht geladen werden.",
    "request_canceled": "Die Anfrage wurde durch eine Bedingung (nicht angemeldet) abgebrochen.",
    "success_activated": "Erfolgreich aktiviert",
    "success_deactivated": "Erfolgreich deaktiviert",
    "success_saved": "Erfolgreich gespeichert",
    "success_saved_to_clipboard": "In Zwischenablage kopiert.",
    "validation_errors_headers": "Validierungsfehler aufgetreten",
    "validation_errors_text": "Beim Bearbeiten des Datensatzes ist es zu Validierungsfehlern gekommen. Bitte korrigieren Sie diese in der Detailansicht.",
    "view_not_available_header": "Displaygröße",
    "view_not_available_text": "Die zur Zeit verwendete Displaygröße ist für die angeforderte Funktionalität zu klein.",
    "warning_invalid_infusion_protocol": "Fehlerhaftes Infusionsprotokoll.",
    "warning_saved_to_clipboard": "Die Daten konnten nicht in Zwischenablage kopiert werden.",
    "warning_saved_to_clipboard_no_data": "Es konnte keine Verordnung gefunden werden."
  },
  "metadata": {
    "booleanTypes": {
      "false": "Nein",
      "true": "Ja"
    },
    "categories": {
      "analgesia": "Analgesie",
      "antibiosis": "Antibiose",
      "antibody": "MAK",
      "antibody_zyto": "MAK+Zyto",
      "folinate": "Folinate",
      "other": "Sonstige",
      "zyto": "Zytostatika",
      "zytoralia": "Oralia/Zytoralia"
    },
    "dayOfWeek": {
      "friday": "Freitag",
      "friday_short": "Fr.",
      "monday": "Montag",
      "monday_short": "Mo.",
      "saturday": "Samstag",
      "saturday_short": "Sa.",
      "sunday": "Sonntag",
      "sunday_short": "So.",
      "thursday": "Donnerstag",
      "thursday_short": "Do.",
      "tuesday": "Dienstag",
      "tuesday_short": "Di.",
      "wednesday": "Mittwoch",
      "wednesday_short": "Mi."
    },
    "frequency_groups": {
      "average": "Durchschnittlich verwendet",
      "hardly": "Kaum verwendet",
      "most": "Am meisten verwendet"
    },
    "genderTypes": {
      "d": "divers",
      "m": "männlich",
      "u": "unbekannt",
      "w": "weiblich",
      "x": "keine Angabe / unbestimmt"
    },
    "insuranceStates": {
      "co-payment": "zuzahlungspflichtig",
      "exempt": "zuzahlungsbefreit",
      "legal": "gesetzlich",
      "others": "sonstige",
      "private": "privat",
      "self-payment": "Selbstzahler"
    },
    "salutationValues": {
      "m": "Herr",
      "s": "Divers",
      "w": "Frau"
    },
    "userTypes": {
      "1": "ROOT",
      "11": "user"
    }
  },
  "msg": {
    "hello": "Hallo Welt!",
    "test": "%{msg} Nachricht!"
  },
  "navigation": {
    "account": {
      "title": "Accountverwaltung",
      "tooltip": {
        "h": "Account",
        "t": "Hier können Sie Ihren Account verwalten."
      }
    },
    "administration": {
      "title": "Administration",
      "tooltip": {
        "h": "Administration",
        "t": "Hier können Sie alle Einstellungen für die Verwendung von TumorPrax vornehmen."
      }
    },
    "audit": {
      "description": "Hier können Sie alle Audit-Einträge anzeigen lassen und suchen",
      "title": "Audit",
      "tooltip": {
        "h": "Audit",
        "t": "Hier können Sie alle Audit-Einträge anzeigen lassen und suchen"
      }
    },
    "dashboard": {
      "description": "Dashboard",
      "subtitle": "Ihre Übersicht",
      "title": "Dashboard",
      "tooltip": {
        "h": "Übersicht in Dashboard",
        "t": " "
      }
    },
    "data_security": {
      "title": "Datenschutz"
    },
    "employee": {
      "description": "Liste aller Mitarbeiter",
      "title": "Mitarbeiter",
      "tooltip": {
        "h": "Mitarbeiterverwaltung",
        "t": "Übersicht zu den Mitarbeiter, Detailansicht, Anlegen eines neuen Mitarbeiter"
      }
    },
    "imports": {
      "description": "Aktueller Import aus dem AIS",
      "title": "Import"
    },
    "imprint": {
      "title": "Impressum"
    },
    "infosystem": {
      "agents": {
        "description": "Liste aller Wirkstoffe",
        "title": "Wirkstoffe"
      },
      "description": "Übersicht über Wirkstoffe, Masterschemen, Praxisschemen",
      "masterschema": {
        "description": "Liste aller Masterschemen",
        "title": "Masterschemen"
      },
      "praxisschema": {
        "description": "Liste aller Praxisschemen",
        "title": "Praxisschemen"
      },
      "title": "Infosystem",
      "tooltip": {
        "h": "Infosystem",
        "t": "Übersicht über Wirkstoffe, Masterschemen, Praxisschemen"
      }
    },
    "infusionProtocols": {
      "description": "Übersicht aller Infusionsprotokolle",
      "title": "Infusionsprotokolle",
      "tooltip": {
        "h": "Infusionsprotokolle",
        "t": "Übersicht aller Infusionsprotokolle"
      }
    },
    "invitations": {
      "description": "Liste aller Einladungen",
      "title": "Einladungen",
      "tooltip": {
        "h": "Einladungen",
        "t": "Übersicht zu aktuell laufenden Einladungen"
      }
    },
    "layout": {
      "default": "Standard",
      "description": "Verwenden sie multible Tabs anstatt einzelne Ansichten",
      "layout_construction": "Layout-Aufbau",
      "layout_size": "Layout-Größe",
      "switchLayout": {
        "title": "Vertikales Layout",
        "tooltip": {
          "h": "Wechseln Sie ihr Layout",
          "t": "Layout wechseln"
        }
      },
      "title": "Layout"
    },
    "locations": {
      "description": "Liste aller Standorte",
      "title": "Standorte",
      "tooltip": {
        "h": "Standorte",
        "t": "Übersicht zu den Standorten, Detailansicht, Anlegen eines neuen Standortes"
      }
    },
    "mode": {
      "expansionPanel": {
        "brightness": {
          "header": "Helligkeitsmodus ändern",
          "subheader": "Wechseln Sie zwischen hellem und dunklem Design"
        },
        "color": {
          "header": "Farbschema ändern",
          "subheader": "Wechseln Sie die Primärfarbe des Designs"
        },
        "language": {
          "description": "Stellen Sie die Anwendung auf Ihre Muttersprache um",
          "title": "Sprachauswahl"
        },
        "layout": {
          "header": "Verticales/Horizontales Layout",
          "subheader": "Wechseln Sie zwischen einem vertikalen und horizontalen Layout",
          "switchIsActive": {
            "title": "isActive",
            "tooltip": {
              "h": "Aktivität setzen",
              "t": "Aktivität setzen"
            }
          }
        },
        "tabLayout": {
          "header": "Tab-Layout",
          "subheader": "Verwenden sie multible Tabs anstatt einzelne Ansichten",
          "switchIsActive": {
            "title": "isActive",
            "tooltip": {
              "h": "Aktivität setzen",
              "t": "Aktivität setzen"
            }
          }
        },
        "widthLayout": {
          "description": "Wechseln Sie zu einem schmaleren Layout mit mehr angezeigten Elementen",
          "title": "Schmaleres Layout"
        }
      },
      "title": "Modus",
      "tooltip": {
        "h": "Modus wählen",
        "t": "Auswahl von Helligkeit, Farbe, Layout, Sprache"
      }
    },
    "partner": {
      "description": "Liste aller Geschäftspartner",
      "title": "Geschäftspartner",
      "tooltip": {
        "h": "Geschäftspartnerverwaltung",
        "t": "Ünersicht zu den Geschäftspartnern, Detailansicht, Anlegen eines neuen Geschäftspartners"
      }
    },
    "patients": {
      "description": "Liste aller Patienten",
      "title": "Patienten",
      "tooltip": {
        "h": "Patienten",
        "t": "Übersicht zu den Patienten, Detailansicht, Anlegen eines neuen Patienten"
      }
    },
    "physician_main": {
      "description": "Übersichten von Patienten, Therapien und Infusionsprotokollen",
      "title": "Hauptmenü"
    },
    "settings": {
      "description": "Verwaltungen von Stammdaten, Einstellungen, Urlaubseinstellungen, Krankenkassen",
      "description2": "Verwaltung von Stammdaten",
      "insurance_company": {
        "description": "Krankenkassen/Krankenversicherungen",
        "title": "Kostenträger"
      },
      "my_holidays": {
        "description": "Urlaubseinstellungen und gesetzliche Feiertage",
        "title": "Urlaubseinstellungen"
      },
      "my_location": {
        "description": "Stammdaten des Standortes",
        "title": "Stammdaten"
      },
      "my_settings": {
        "description": "Einstellungen des Standortes",
        "title": "Einstellungen"
      },
      "title": "Einstellungen",
      "tooltip": {
        "h": "Einstellungen",
        "t": "Übersicht über Stammdaten, Einstellungen, Urlaubseinstellungen, Krankenkassen"
      }
    },
    "therapies": {
      "description": "Übersicht aller Therapien",
      "title": "Therapien",
      "tooltip": {
        "h": "Therapien",
        "t": "Übersicht aller Therapien"
      }
    },
    "users": {
      "description": "Liste aller Nutzer",
      "title": "Nutzer",
      "tooltip": {
        "h": "Nutzerverwaltung",
        "t": "Übersicht zu den Nutzern, Detailansicht, Anlegen eines neuen Nutzers"
      }
    }
  },
  "partners": {
    "basic_order": "Basisbestellung",
    "pharmacy": "Apotheke",
    "pharmacy_link": "Apotheke",
    "physician": "Arzt",
    "physician_link": "Arzt"
  },
  "popup_add_cycles": {
    "agent": "Wirkstoff",
    "carrier_solution": "Trägerlösung",
    "cycle_added": "Zyklus hinzugefügt",
    "cycle_start": "Startzyklus",
    "date_start": "Startdatum",
    "day": "Tag",
    "days_delay": "{days} Tage Verschiebung",
    "dosage": "Dosis",
    "error_no_item_selected": "Fehler: Es sind keine Therapien ausgewählt.",
    "header": {
      "cycle_details": "Zyklusdetails",
      "cycle_therapies": "Therapiezyklus",
      "initial_dosage": "Initial Dosierungen",
      "vital_data": "Vitaldaten"
    },
    "info_text_use_initial_data": "Initialdosierung verwenden",
    "length_of_cycle": "Zykluslänge (in Tagen)",
    "manufacturer": "Hersteller",
    "number_of_cycles": "Anzahl der Zyklen",
    "number_of_cycles_add": "Anzahl Zyklen hinzufügen",
    "number_of_existing_cycles": "Anzahl bestehender Zyklen",
    "regular_start": "regulärer Start",
    "required": "Pflichtfeld",
    "schema_dosage": "Dosierung",
    "schema_initial_dosage": "Init. Dosierung",
    "time_start": "Uhrzeit",
    "title": "Patientenschema - Therapien erstellen",
    "tooltip_warning_holiday_weekend": {
      "h": "Startdatum am Wochenende oder im Urlaub/gesetzlicher Feiertag",
      "t": ""
    },
    "use_initial_dosages": {
      "false": "Initialdosierungen nicht verwenden",
      "true": "Initialdosierungen verwenden"
    }
  },
  "popup_add_insurance_company": {
    "title_edit": "Kostenträger bearbeiten",
    "title_new": "Kostenträger anlegen"
  },
  "popup_add_negative_days": {
    "application_date": "Datum",
    "days_delay": "{days} Tage Verschiebung",
    "header": {
      "text": "Applikationsdatum vorziehen"
    },
    "select_date": "Datum auswählen"
  },
  "popup_add_per_pin": {
    "pharmacy": "Apotheke per PIN suchen ",
    "physician": "Vertretungsarzt per PIN suchen",
    "tab": {
      "title": "",
      "title_pharmacy": "Neue Apotheke (PIN)",
      "title_physician": "Neuer Vertretungsarzt (PIN)"
    },
    "title": "PIN Eingabe"
  },
  "popup_add_schema_break": {
    "break_description": "Bemerkungen",
    "break_length": "Länge der Verschiebung (in Tagen)",
    "break_start_date": "Datum Beginn Verschiebung",
    "break_type_negative": "Verkürzen",
    "break_type_negative_h": "Verkürzen",
    "break_type_negative_t": "Zykluslänge verkürzen",
    "break_type_positive": "Verlängern",
    "break_type_positive_h": "Verlängern",
    "break_type_positive_t": "Zykluslänge verlängern",
    "common_details": "Allgemeine Details",
    "date_start": "Beginn",
    "description": "Bemerkungen",
    "existing_breaks": "Vorhandene Verschiebungen",
    "length_of_break": "Verschiebung in Tagen",
    "length_of_break_long": "Verlängerung in Tagen",
    "length_of_break_short": "Verkürzung in Tagen",
    "title": "Therapien verschieben durch Anpassung der Zykluslänge"
  },
  "popup_add_schema_break_from_holiday": {
    "break_type_ignore": "Ignorieren",
    "break_type_use": "Verwenden",
    "common_details": "Allgemeine Details",
    "company_holiday": "Urlaubseintrag:",
    "date_from": "Beginn",
    "date_to": "Bis",
    "length_of_break": "Länge der Verschiebung (in Tagen)",
    "public_holiday": "Gesetzlicher Feiertag:",
    "title": "Therapie verschieben",
    "type_company": "Praxisurlaub",
    "type_public": "Gesetzlicher Feiertag",
    "warning_break_found": "Bei der Erstellung von Therapien gibt es einen Konflikt mit Urlaubseinträgen oder gesetzlichen Feiertagen."
  },
  "popup_add_vital_data": {
    "bmi": "BMI",
    "creatinine": "Kreatinin",
    "creatinine_clearance": "Kreatinin-Clearance",
    "creatinine_clearance_methods": {
      "cockcroft": "Cockcroft-Gault",
      "jellife": "Jellife"
    },
    "date": "Datum",
    "ecog": "ECOG Index",
    "height": "Größe",
    "ideal_weight": "Idealgewicht",
    "karnofsky_index": "Karnofsky-Index in %",
    "kof_methods": {
      "dubois": "Dubois",
      "manual": "manuell",
      "manuell": "manuell",
      "mosteller": "Mosteller"
    },
    "skin_surface": "Körperoberfläche",
    "skin_surface_method": "Berechnung",
    "title": "Vitaldaten hinzufügen",
    "vital_data_differ_strongly": "Die eingegebenen Vitaldaten weichen stark von denen das letzte Mal eingegebenen Vitaldaten ab. Sind diese korrekt?",
    "vital_data_no_creatinine_data": "Es gibt noch geplante Therapien mit dem Wirkstoff Carboplatin, welche zur Berechnung der Dosierung einen Kreatinin Wert benötigen.",
    "warning_creatinine_gt": "Der eingegebene Wert liegt oberhalb des typischen Wertebereichs von {expected} mg/dl, ist dies beabsichtigt?",
    "warning_creatinine_lt": "Der eingegebene Wert liegt unterhalb des typischen Wertebereichs von {expected} mg/dl, ist dies beabsichtigt?",
    "warning_creatinine_mol_gt": "Der eingegebene Wert liegt oberhalb des typischen Wertebereichs von {expected} µmol/l, ist dies beabsichtigt?",
    "warning_creatinine_mol_lt": "Der eingegebene Wert liegt unterhalb des typischen Wertebereichs von {expected} µmol/l, ist dies beabsichtigt?",
    "warning_text_changing_vital_data": "Bei Eingabe aktueller Vitaldaten werden alle bereits geplanten Zubereitungen neu berechnet.",
    "weight": "Gewicht"
  },
  "popup_approve_basic_order": {
    "header": {
      "passcode": "Auth-Code eingeben",
      "password": "Passwort eingeben",
      "text": "Zur Bestätigung der Freigabe der Anforderung wird Ihr Passwort benötigt."
    },
    "password": "Passwort"
  },
  "popup_approve_therapies": {
    "header": {
      "passcode": "Auth-Code eingeben",
      "password": "Passwort eingeben",
      "text": "Zur Bestätigung der Freigabe von Therapien wird Ihr Passwort benötigt."
    },
    "password": "Passwort"
  },
  "popup_captcha_confirm": {
    "default_header": "Aktion bestätigen",
    "text": "Um die Aktion zu bestätigen, klicken Sie bitte die Schaltfläche mit der Nummer"
  },
  "popup_carrier_solutions": {
    "application": "Applikation",
    "application_routes": "Applikationsweg",
    "carrier_solution": "Wässerung",
    "day": "Tag",
    "dosage": "Dosierung",
    "hint": "Erlaubte Zeichen sind '0-9', '-' und ','",
    "infusion_duration_hours": "Infusionsdauer Stunden",
    "infusion_duration_minutes": "Infusionsdauer Minuten",
    "scheduling_duration": "Zeitl. Ablauf",
    "select_application_routes": "Applikationsweg",
    "subtitle": {
      "edit": "An dieser Stelle können Sie die Wässerung bearbeiten.",
      "new": "An dieser Stelle können Sie die Wässerung hinzufügen."
    },
    "title": {
      "edit": "Wässerung bearbeiten",
      "new": "Wässerung hinzufügen"
    },
    "toggle_buttons": {
      "glucose": "Glucose 5%",
      "nacl": "NaCl 0,9%",
      "other_carrier_solution": "Sonstige Wässerung",
      "other_volume": "Sonstiges Volumen"
    },
    "unit": "Einheit",
    "volume": "Volumen"
  },
  "popup_change_email": {
    "confirm_btn": "Verstanden",
    "confirm_text": "Um den Vorgang abzuschließen, wurde eine E-Mail an die neue Adresse geschickt. Bitte verwenden Sie den darin enthaltenen Link um die E-Mail-Änderung zu bestätigen.",
    "email": "Neue E-Mail-Adresse",
    "email_placeholder": "Bitte tragen Sie hier Ihre neue E-Mail-Adresse ein.",
    "info_text": "Um Ihre E-Mail-Adresse zu ändern, geben Sie zunächst Ihre neue E-Mail-Adresse sowie Ihr Passwort in das entsprechende Feld ein und klicken anschließend auf den Button 'Übernehmen'. Im Erfolgsfalle erhalten Sie an Ihre neue E-Mail-Adresse eine Nachricht.",
    "password": "Passwort",
    "password_placeholder": "Bitte tragen Sie hier Ihr Passwort ein.",
    "subtitle": "An dieser Stelle können Sie ihre E-Mail ändern",
    "successfully_saved": "E-Mail erfolgreich gespeichert",
    "title": "E-Mail ändern"
  },
  "popup_change_login_name": {
    "info_text": "Um Ihren Benutzernamen zu ändern, geben Sie zunächst Ihren neuen Benutzernamen sowie Ihr Passwort in das entsprechende Feld ein und klicken anschließend auf den Button 'Übernehmen'. Im Erfolgsfalle erhalten Sie an Ihre E-Mail-Adresse eine Nachricht.",
    "login": "Neuer Benutzername",
    "login_placeholder": "Bitte tragen Sie hier Ihren neuen Benutzername ein.",
    "password": "Passwort",
    "password_placeholder": "Bitte tragen Sie hier Ihr Passwort ein.",
    "subtitle": "An dieser Stelle können Sie ihren Benutzernamen ändern",
    "successfully_saved": "Benutzername erfolgreich gespeichert",
    "title": "Benutzername ändern"
  },
  "popup_change_opening_hours": {
    "and": " und ",
    "conflict": "Es wurde kein Wochentag ausgewählt.",
    "end": "Ende",
    "info_text": "Wählen Sie den Wochentag und bestimmen Sie, ob es ein Ruhetag ist. Ist dies nicht der Fall, legen Sie das erste Zeitfenster fest (z.B. 6:00–12:00 Uhr). Weitere Zeitfenster (z.B. 13:00–19:00 Uhr) fügen Sie durch Wiederholung des Vorgangs hinzu. Es sind unbegrenzt viele Zeitfenster pro Tag möglich.",
    "o_clock": "Uhr",
    "rest": "Ruhetag",
    "start": "Beginn",
    "title": "Öffnungszeiten",
    "tooltip": {
      "h": "Gesperrt",
      "t": "Bitte wählen Sie als erstes einen Tag aus, für den Sie den Ruhetag oder die Öffnungszeiten vergeben wollen."
    }
  },
  "popup_change_password": {
    "info_text": "Um Ihr Passwort zu ändern, geben Sie zunächst Ihr altes Passwort und anschließend Ihr neues Passwort ein. Um die Änderung abzuschließen, klicken Sie auf den Button 'Übernehmen'.",
    "info_text_2": "**__Passwortregeln:__**##-br-## 1) das Passwort muss mindestens 6 Zeichen enthalten##-br-## 2) es darf nicht ihr Benutzername als Passwort verwendet werden, bzw. keine zu große Ähnlichkeit mit ihrem Benutzernamen bestehen##-br-## 3)  es darf nicht ihre E-Mail als Passwort verwendet werden, bzw. keine zu große Ähnlichkeit mit ihrer E-Mail bestehen",
    "old_password": "Altes Passwort",
    "old_password_placeholder": "Bitte tragen Sie hier Ihr altes Passwort ein.",
    "password": "Neues Passwort",
    "password2": "Neues Passwort wiederholen",
    "password2_placeholder": "Bitte wiederholen Sie hier Ihr neues Passwort.",
    "password_placeholder": "Bitte tragen Sie hier Ihr neues Passwort ein.",
    "subtitle": "An dieser Stelle können Sie ihr Passwort ändern",
    "successfully_saved": "Passwort erfolgreich gespeichert",
    "title": "Passwort ändern"
  },
  "popup_close_patient_schema": {
    "close_date": "Beendet am",
    "close_reason": "Grund",
    "common_details": "Allgemeine Details",
    "description": "Bemerkungen",
    "reason_type": {
      "abort": "Abbruch",
      "fail": "Fehlgeschlagen",
      "success": "Erfolg"
    },
    "title": "Patientenschema beenden"
  },
  "popup_concomitant_disease": {
    "subtitle": {
      "edit": "An dieser Stelle können Sie eine bestehende Begleit-/Nebenerkrankung bearbeiten",
      "new": "An dieser Stelle können Sie eine neue Begleit-/Nebenerkrankung hinzufügen."
    },
    "title": {
      "edit": "Bestehende Begleit-/Nebenerkrankung bearbeiten",
      "new": "Neue Begleit-/Nebenerkrankung erstellen"
    }
  },
  "popup_confirm": {
    "title": "Bestätigung"
  },
  "popup_create_application_overview": {
    "checkboxes": {
      "no": "Nein",
      "yes": "Ja"
    },
    "choose_timespan": "Zeitraum auswählen",
    "complete_timespan": "Gesamter Zeitraum?",
    "end_date_overview": "Endzeitpunkt",
    "start_date_overview": "Startzeitpunkt",
    "title": "Applikationsübersicht erstellen"
  },
  "popup_create_missing_therapies": {
    "agent": "Wirkstoff",
    "carrier_solution": "Trägerlösung",
    "day": "Tag",
    "dosage": "Dosis",
    "header": {
      "missing_therapies": "Fehlende Therapien",
      "vital_data": "Vitaldaten"
    },
    "manufacturer": "Hersteller",
    "schema_dosage": "Dosierung",
    "schema_initial_dosage": "Initialdosierung",
    "selected": "(ausgewählt)",
    "title": "Fehlende Therapien des {idx}. Zyklus erstellen",
    "warning_no_item_selected": "Es wurden noch keine Therapien ausgewählt. Bitte wählen Sie mindestens eine Therapie aus, um fortzufahren."
  },
  "popup_create_new_patient_schema": {
    "alternative_name": "Alternativname",
    "btn_all_schemas": {
      "label": "Masterschemen + Praxisschemen",
      "tooltip": "Masterschemen und Praxisschemen zur Auswahl anzeigen"
    },
    "btn_only_master_schema": {
      "label": "Masterschemen",
      "tooltip": "Nur Masterschemen zur Auswahl anzeigen"
    },
    "btn_only_praxis_schema": {
      "label": "Praxisschemen",
      "tooltip": "Nur Praxisschemen zur Auswahl anzeigen"
    },
    "create_empty_patient_schema": "Leeres Patientenschema erstellen",
    "icd": "ICD-10",
    "icd_switch": "Nach ICD-10 Codes des Patienten filtern ({icds})",
    "indication": "Indikation",
    "length_of_cycle": "Zyklusdauer",
    "name": "Name",
    "number_of_cycles": "Anzahl Zyklen",
    "title": "Neues Patientenschema anlegen"
  },
  "popup_diagnosis": {
    "date": "Diagnosedatum",
    "date_accuracy": "Datumsgenauigkeit",
    "icd_code": "ICD-10 Code",
    "icd_code_text": "Diagnosetext",
    "icd_code_version": "ICD-10 Version",
    "icd_code_version_hint": "Bei Änderung der Version wird der Code zurückgesetzt.",
    "icd_pattern_types": "Folgende ICD-10 Codes stehen zur Verfügung: {icds}",
    "side_localization": "Seitenlokalisation",
    "side_localization_paired_tumor": "Seitenlokalisation paariger Tumor",
    "subtitle": {
      "edit": "An dieser Stelle können Sie eine bestehende Diagnose bearbeiten",
      "new": "An dieser Stelle können Sie eine neue Diagnose hinzufügen."
    },
    "title": {
      "edit": "Bestehende Diagnose bearbeiten",
      "new": "Neue Diagnose erstellen"
    },
    "tooltip_date_accuracy": "Bei Eingabe des Datums wird die Datumsgenauigkeit automatisch auf \"E\" für exakt gesetzt. Sollte die Genauigkeit abweichen, so wählen Sie die entsprechende Abweichung aus."
  },
  "popup_discard_patient": {
    "ignore_dialog_message": "Wollen Sie diesen Patient/diese Patientin für den aktuellen Import verwerfen?",
    "ignore_dialog_message_part1": "Alle gemachten Änderungen gehen verloren.",
    "ignore_dialog_message_part2": "Klicken Sie auf \"Patient dauerhaft für Import sperren\", um den Patient/die Patientin permanent für kommende Importe zu ignorieren.",
    "title": "Patient verwerfen"
  },
  "popup_dosage_reduction": {
    "header": {
      "percentage": "Dosisreduktion",
      "text": "Neue Dosisreduktion"
    },
    "value_from_original_dose": "% Wert von Originaldosis",
    "warning_below_dosage": "Unterdosierung (< 95%)",
    "warning_over_dosage": "Überdosierung (> 105%)"
  },
  "popup_import": {
    "message": "Alle Daten des bestehenden Imports und alle bisher nicht in die Patientenverwaltung übernommenen Änderungen werden verworfen. Dieser Vorgang kann nicht rückgängig gemacht werden. Möchten Sie wirklich einen neuen Import starten?",
    "selected_file": "ausgewählte Datei:",
    "title": "Neuen Import starten"
  },
  "popup_imprint": {
    "subtitle": "An dieser Stelle können Sie alles über Datenschutz und Sicherheit erfahren.",
    "title": "Impressum"
  },
  "popup_infusion_protocol": {
    "application_route": "Appl.",
    "b": "B",
    "base_dosage": "Basisdosierung",
    "buttons": {
      "add_information": "Hinzufügen",
      "add_solution": "Lösung hinzufügen",
      "add_text": "Freitextfeld hinzufügen",
      "submit": "Übernehmen"
    },
    "carrier_solution": "Trägerlösung (ml)",
    "comment": "Kommentar",
    "day": "Tag",
    "dosage": "Dosierung",
    "info_text": "Text",
    "info_title": "Bezeichnung",
    "infusion_duration": "Inf.-Dauer",
    "init_dosage": "Init. Dosierung:",
    "init_infusion_duration": "Init. Inf.-Dauer:",
    "legend": {
      "agent": "Wirkstoff",
      "legend": "Legende:",
      "medication": "Medikation",
      "solution": "Wässerung",
      "text": "Freitextfeld"
    },
    "medication_name": "Medikation",
    "no_info": "Keine Informationen hinzugefügt.",
    "panels": {
      "information": "Informationen",
      "medication": "Prä- und Postmedikation",
      "oral_medication": "Orale Medikation",
      "substances": "Substanzen"
    },
    "scheduling_duration": "Zeitl. Ablauf",
    "title": "Infusionsprotokollvorlage",
    "tooltip_infusion_protocol": "Infusionsprotokollvorlage",
    "tooltip_infusion_protocol_create": "Infusionsprotokollvorlage erstellen",
    "tooltip_infusion_protocol_edit": "Infusionsprotokollvorlage bearbeiten"
  },
  "popup_infusion_protocol_read_only": {
    "title": "Infusionsprotokollvorlage ansehen"
  },
  "popup_location_selection": {
    "title": "Standort wechseln"
  },
  "popup_migrate_partners": {
    "autocomplete": "Name",
    "error_invalid_route": "Invalide Route beim Restserver",
    "error_no_server": "Kein Restserver vorhanden",
    "header": {
      "panel": "Arzt suchen",
      "text": "Geschäftspartner (Arzt) migrieren"
    }
  },
  "popup_notification": {
    "title": "Bemerkung"
  },
  "popup_order_basic_order": {
    "agent": "Wirkstoff",
    "cycle": "Zyklus",
    "date": "Datum",
    "day": "Tag",
    "dosage": "Dosierung",
    "dosis": "Dosis",
    "header": {
      "additional_options": "Zusätzliche Bestelloptionen",
      "choose_pharmacy": "Apotheke auswählen",
      "text": "Anforderung bestellen",
      "therapy_list": "Übersicht der bestellten Therapien"
    },
    "pharmacy": "Apotheke"
  },
  "popup_order_therapies": {
    "header": {
      "choose_pharmacy": "Apotheke auswählen",
      "text": "Therapiebestellung"
    },
    "pharmacy": "Apotheke"
  },
  "popup_re_login": {
    "error_wrong_login": "Sie konnten nicht angemeldet werden.",
    "info_text": "Nach längerer Inaktivität wurden Sie aus Sicherheitsgründen automatisch ausgeloggt. Um Ihre Arbeit fortzusetzen, authentifizieren Sie sich bitte erneut.",
    "login": "Benutzername oder Email",
    "login_placeholder": "Bitte tragen Sie hier Ihren Benutzernamen oder ihre E-Mail ein.",
    "password": "Passwort",
    "password_placeholder": "Bitte tragen Sie hier Ihr Passwort ein.",
    "title": "Neuauthentifizierung"
  },
  "popup_selected_master_schema": {
    "create_empty_praxis_schema": "Leeres Praxisschema anlegen",
    "title": "Neues Praxisschema anlegen (leer oder von einem Masterschema)"
  },
  "popup_support": {
    "send_support": "Nachricht gesendet",
    "send_user_copy": "Eine Kopie der Nachricht erhalten",
    "support_successfully_send": "Die Nachricht wurde erfolgreich gesendet",
    "support_text": "Support Text",
    "title": "Support"
  },
  "popup_therapies_wrong_status": {
    "action": {
      "apply": "Verabreichen",
      "approve": "Freigabe",
      "cancel": "Absagen",
      "delete": "Löschen",
      "order": "Bestellen"
    },
    "message_failed_order_therapies_multi": "Die Aktion ist für {count} Therapien fehlgeschlagen.",
    "message_failed_order_therapies_single": "Die Aktion ist für {count} Therapie fehlgeschlagen.",
    "message_therapies_wrong_application_date_multi": "{count} ausgewählte Therapien haben ein falsches Applikationsdatum für die Aktion:",
    "message_therapies_wrong_application_date_single": "{count} ausgewählte Therapie hat ein falsches Applikationsdatum für die Aktion:",
    "message_wrong_therapy_status_multi": "{count} ausgewählte Therapien haben einen falschen Status für die Aktion:",
    "message_wrong_therapy_status_single": "{count} ausgewählte Therapie hat einen falschen Status für die Aktion:",
    "therapies_wrong_application_date": "Therapien mit falschem Applikationsdatum:",
    "therapies_wrong_status": "Therapien mit falschem Status:",
    "title": "Status setzen"
  },
  "popup_therapy_agents": {
    "agent": "Wirkstoff",
    "alert": {
      "agent_inactive": "Der Wirkstoff ist inaktiv.",
      "agent_revise": "Die hinterlegten Wirkstoffdaten sind nicht mehr gültig.",
      "check_application_form": "Die ausgewählte Applikationsart ist bei diesem Wirkstoff nicht hinterlegt.",
      "check_application_route": "Der ausgewählte Applikationsweg ist bei diesem Wirkstoff nicht hinterlegt."
    },
    "application": "Applikation",
    "application_form": "Applikationsart",
    "application_route": "Applikationsweg",
    "button": {
      "addAgent": "Wirkstoff hinzufügen"
    },
    "carrier_solution": "Trägerlösung",
    "day": "Tag",
    "dosage": "Dosierung",
    "hint": "Erlaubte Zeichen sind '0-9', '-' und ','",
    "infusion_duration_hours": "Infusionsdauer Stunden",
    "infusion_duration_minutes": "Infusionsdauer Minuten",
    "initial_dosage": "Initialdosierung",
    "initial_infusion_duration_hours": "Initial Infusionsdauer Stunden",
    "initial_infusion_duration_minutes": "Initial Infusionsdauer Minuten",
    "mixed_infusion": "Mischinfusion",
    "no_agent": "Kein Wirkstoff hinzugefügt",
    "scheduling_duration": "Zeitlicher Ablauf",
    "subtitle": {
      "edit": "Bearbeiten Sie einen oder mehrere Wirkstoffe für Ihr Masterschema.",
      "new": "Legen Sie einen oder mehrere Wirkstoffe für Ihr Masterschema an."
    },
    "title": {
      "edit": "Wirkstoff für Substanz hinzufügen",
      "new": "Wirkstoff für Substanz überarbeiten"
    },
    "total_volume": "Gesamtvolumen",
    "unit": "Einheit"
  },
  "popup_therapy_agents_concomitant": {
    "agent": "Wirkstoff",
    "application_route": "Applikationsweg",
    "day": "Tag",
    "dosage": "Dosierung",
    "hint": "Erlaubte Zeichen sind '0-9', '-' und ','",
    "scheduling_duration": "Zeitlicher Ablauf",
    "subtitle": {
      "edit": "An dieser Stelle können Sie Begleitmedikation bearbeiten",
      "new": "An dieser Stelle können Sie Begleitmedikation hinzufügen."
    },
    "title": {
      "edit": "Wirkstoff für Begleitmedikation bearbeiten",
      "new": "Wirkstoff für Begleitmedikation hinzufügen"
    },
    "unit": "Einheit"
  },
  "popup_therapy_agents_oral": {
    "agent": "Wirkstoff",
    "comment": "Kommentar",
    "day": "Tag",
    "dosage": "Dosierung",
    "hint": "Erlaubte Zeichen sind '0-9', '-' und ','",
    "subtitle": {
      "edit": "An dieser Stelle können Sie orale Substanzen bearbeiten",
      "new": "An dieser Stelle können Sie orale Substanzen hinzufügen."
    },
    "taking_types": {
      "evening": "abends",
      "morning": "früh",
      "night": "nachts",
      "noon": "mittags"
    },
    "takings": "Einnahme",
    "title": {
      "edit": "Wirkstoff für orale Substanz bearbeiten",
      "new": "Wirkstoff für orale Substanz hinzufügen"
    },
    "unit": "Einheit"
  },
  "popup_therapy_agents_proprietary": {
    "agent": "Wirkstoff",
    "application_route": "Applikationsweg",
    "comment": "Kommentar",
    "day": "Tag",
    "dosage": "Dosierung",
    "hint": "Erlaubte Zeichen sind '0-9', '-' und ','",
    "scheduling_duration": "Zeitlicher Ablauf",
    "subtitle": {
      "edit": "An dieser Stelle können Sie eine Prä-/Postmedikation bearbeiten",
      "new": "An dieser Stelle können Sie eine Prä-/Postmedikation hinzufügen."
    },
    "title": {
      "edit": "Wirkstoff für Prä-/Postmedikation bearbeiten",
      "new": "Wirkstoff für Prä-/Postmedikation hinzufügen"
    },
    "unit": "Einheit"
  },
  "popup_therapy_status": {
    "change_status": "Status ändern",
    "current_status": "Aktueller Status",
    "new_status": "Neuer Status",
    "status_history": "Status Historie",
    "subtitle": "An dieser Stelle können Sie den Status ändern",
    "title": "Statusverlauf",
    "user": "Benutzer:"
  },
  "popup_two_factor_activation": {
    "step_0": {
      "app_app": "Eine {company} Anwendung zur Generierung von Zugriffscodes",
      "app_authentificator": "{company} Authentificator",
      "continue": "Fortfahren",
      "hint": "Bitte entfernen Sie die Authentifizierungs-App niemals von ihrem Smartphone, da Sie sonst den Zugang zu ihrem Account verlieren könnten.",
      "info_text": "Um die Zweifaktorauthentifizierung nutzen zu können, benötigen Sie ein Smartphone und eine App zur Erzeugung von Zugangsschlüsseln. Im Folgenden haben Sie die Möglichkeit, je nach Betriebssystem ihres Smartphones, verschiedene Apps zur Authentifizierung herunterzuladen und zu installieren.",
      "or": "oder"
    },
    "step_1": {
      "continue": "Fortfahren",
      "or": "oder",
      "text_1": "Wenn Sie sich über ein anderes Gerät anmelden wollen oder Sie nicht mehr auf Ihren mobilen Authentifikator zugreifen können, verwenden Sie den QR-Code oder geben Sie den generierten Schlüssel manuell ein.",
      "text_2": "Scannen Sie den QR-Code",
      "text_3": "Starten Sie in der installierten App das Setup (oder fügen Sie ein neues Konto hinzu) und scannen Sie dann den QR-Code mit Ihrer Kamera.",
      "text_4": "Geheimen Schlüssel eingeben",
      "text_5": "Wenn Sie den QR-Code nicht scannen können, wählen Sie die manuelle Eingabe aus geben Sie dann Ihre E-Mail-Adresse (sofern benötigt) und den geheimen Code in die entsprechenden Felder ein.",
      "text_6": "Geben Sie ihren geheimen Schlüssel und QR-Code nicht weiter und zeigen Sie diesen niemanden!"
    },
    "step_2": {
      "access_code": "Zugriffscode",
      "access_code_placeholder": "Zugriffscode eingeben",
      "continue": "Aktivieren + Fortfahren",
      "text_1": "Um die Aktivierung der Zweifaktorauthentifizierung abzuschließen, müssen Sie noch einen Zugriffscode eingeben, den Sie über die Authentikator-App auf ihrem Smartphone generiert haben."
    },
    "step_3": {
      "continue": "Abschließen",
      "text_1": "Die Aktivierung war erfolgreich.",
      "text_2": "Sollten Sie Ihre App einmal nicht zur Verfügung haben oder es gibt Probleme mit der App, dann können diese Backup-Codes nutzen, um Ihren Account zu bearbeiten. Bitte sichern Sie diese Backup-Codes an einem sicheren Ort und zeigen Sie diese niemals anderen."
    },
    "step_4": {
      "access_code": "Zugriffscode",
      "access_code_placeholder": "Zugriffscode eingeben",
      "continue": "Deaktivieren",
      "text_1": "Um die Zweifaktorauthentifizierung zu deaktivieren, geben Sie bitte einen gültigen Zugriffscode aus ihrer Authentikator-App ein."
    },
    "steps_0": "Download",
    "steps_1": "Einrichten",
    "steps_2": "Code",
    "steps_3": "Aktivieren",
    "subtitle": "Nutzen Sie die zusätzliche Authorisierung durch den zweiten Faktor",
    "successfully_activated": "Zweifaktorauthentifizierung wurde erfolgreich aktiviert.",
    "successfully_deactivated": "Zweifaktorauthentifizierung wurde erfolgreich deaktiviert.",
    "title": "Zweifaktorauthentifizierung",
    "title_activate": "2FA aktivieren",
    "title_deactivate": "2FA deaktivieren"
  },
  "popup_two_factor_backup_code": {
    "step_0": {
      "access_code": "Zugriffscode",
      "access_code_placeholder": "Zugriffscode eingeben",
      "continue": "Abschicken",
      "text_1": "Hier können sie sich ihre Backup codes neu generieren lassen geben sie dafür einfach einen Zugriffscode ein."
    },
    "step_1": {
      "continue": "Abschließen",
      "text_1": "Die Aktivierung war erfolgreich.",
      "text_2": "Sollten Sie Ihre App einmal nicht zur Verfügung haben oder es gibt Probleme mit der App, dann können diese Backup-Codes nutzen, um Ihren Account zu bearbeiten. Bitte sichern Sie diese Backup-Codes an einem sicheren Ort und zeigen Sie diese niemals anderen."
    },
    "subtitle": "Generieren sie neue Codes",
    "successfully_saved": "Backup codes wurden erfolgreich generiert.",
    "title": "Neu generieren von Backup Codes"
  },
  "popup_vital_data_history": {
    "header": {
      "history": "Verlauf",
      "text": "Verlauf der Vitaldaten"
    }
  },
  "roles": {
    "basicOrderOncologySpecialist": "Onkologische Fachkraft",
    "basicOrderPhysician": "Arzt",
    "inactive": "Deaktiviert (im aktuellen Standort)",
    "physicianGPAdmin": "Geschäftspartner-Verwalter",
    "physicianOncologySpecialist": "Onkologische Fachkraft",
    "physicianPhysician": "Arzt",
    "physicianUser": "Mitarbeiter",
    "userAdmin": "Benutzeradmin"
  },
  "settings": {
    "change_brightness": "Helligkeitsmodus",
    "change_brightness_subtext": "hell - dunkel",
    "change_color_schema": "Primärfarbe ändern",
    "change_hide_animation": "UI-Animationen",
    "change_hide_animation_subtext": "statisch - animiert",
    "change_language": "Sprachauswahl",
    "change_layout": "Layout ändern",
    "change_layout_appearance": "Layout-Aufbau",
    "change_layout_appearance_tab": "Tab-Layout",
    "change_layout_appearance_vertical": "Vertikales Layout",
    "change_layout_size": "Layout-Größe",
    "change_less_color": "Farbverteilung",
    "change_less_color_subtext": "wenig - viel",
    "header": "Einstellungen",
    "layout_size_default": "Standard",
    "set_tab_value": "Hier können Sie das Tab-Layout setzten.",
    "set_value": "Aktivität setzen",
    "set_vertical_value": "Hier können Sie das vertikale Layout setzten.",
    "tab_layout": "Tab-Layout",
    "tab_layout_subtext": "nein - ja",
    "vertical_layout": "Vertikales Layout"
  },
  "subnavigation": {
    "_subtitleAccount": "Hier können Sie Änderungen an Ihren Accountdaten vornehmen",
    "account": "Account verwalten",
    "imprint": "Impressum",
    "lock": "Sperren",
    "logout": "Abmelden",
    "organization": "Organisation wechseln",
    "subtitleAccount": "Hier können Sie Änderungen an Ihren Accountdaten vornehmen",
    "subtitleImprint": "Alles zum Thema Datenschutz und Sicherheit",
    "subtitleLock": "Falls Sie den Platz nur kurz verlassen wollen",
    "subtitleLogout": "Bitte melden Sie sich immer ordnungsgemäß ab",
    "subtitleOrganization": "Wechseln Sie die aktuell ausgewählte Organisation"
  },
  "therapy_types": {
    "parenteral_nutrition": "Ernährung",
    "proprietary": "Fertigware",
    "therapy": "Therapie",
    "undefined": ""
  },
  "Unauthorized": "Sie verfügen nicht über die entsprechenden Rechte.",
  "user_app": {
    "app_settings": "App-Einstellungen",
    "app_settings_info": "Individualisieren Sie die Anwendung",
    "dashboard": "Dashboard",
    "header_account": "Nutzer-Menu",
    "header_navigation": "Navigation",
    "info_navigation": "Wichtige Informationen auf einen Blick"
  },
  "workflow_states": {
    "physician": {
      "applied": "Verabreicht",
      "approved": "Freigegeben",
      "canceled": "Abgesagt",
      "delivered": "Angeliefert",
      "is_read": "Gelesen in Apotheke",
      "manufactured": "Hergestellt",
      "ordered": "Bestellt",
      "ordered_inactive_partner": "Bestellt",
      "ordered_inactive_partner2": "Bestellt (als PDF)",
      "planned": "Geplant",
      "rejected_by_pharmacy": "Abgelehnt in Apotheke",
      "revoked_by_pharmacy": "Storniert in Apotheke",
      "shipped": "Unterwegs",
      "undefined": ""
    }
  }
}
